/* Sans Armure — motion. No dependencies. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* Reveal on scroll */
  function initReveals(root) {
    var items = (root || document).querySelectorAll('[data-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* Header turns to glass after the hero */
  function initHeader() {
    var header = document.querySelector('[data-header].sa-header--float');
    if (!header) return;
    var tick = false;
    function update() {
      tick = false;
      header.classList.toggle('is-scrolled', window.scrollY > window.innerHeight * 0.55);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Story lights up word by word */
  var wordBlocks = [];
  function splitWords(el) {
    if (el.dataset.split) return;
    el.dataset.split = '1';
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var parts = node.textContent.split(/(\s+)/);
      var frag = document.createDocumentFragment();
      parts.forEach(function (part) {
        if (!part) return;
        if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
        var span = document.createElement('span');
        span.className = 'sa-word';
        span.textContent = part;
        frag.appendChild(span);
      });
      node.parentNode.replaceChild(frag, node);
    });
    wordBlocks.push({ el: el, words: el.querySelectorAll('.sa-word') });
  }
  function updateWords() {
    var vh = window.innerHeight;
    wordBlocks.forEach(function (b) {
      var r = b.el.getBoundingClientRect();
      var start = vh * 0.85, end = vh * 0.35;
      var p = (start - r.top) / ((start - end) + r.height * 0.6);
      p = Math.max(0, Math.min(1, p));
      var lit = Math.round(p * b.words.length);
      for (var i = 0; i < b.words.length; i++) b.words[i].classList.toggle('is-lit', i < lit);
    });
  }
  function initWords(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-words]').forEach(splitWords);
    updateWords();
  }
  var wordTick = false;
  window.addEventListener('scroll', function () {
    if (!wordBlocks.length || wordTick) return;
    wordTick = true;
    requestAnimationFrame(function () { wordTick = false; updateWords(); });
  }, { passive: true });
  window.addEventListener('resize', updateWords);

  /* Jacket stage: drag to spin in 3D, front/back buttons, gentle auto-turn, pointer tilt */
  function initStage(root) {
    (root || document).querySelectorAll('[data-stage]').forEach(function (stage) {
      if (stage.dataset.ready) return;
      stage.dataset.ready = '1';
      var buttons = stage.querySelectorAll('[data-view]');
      var faces = stage.querySelectorAll('[data-face]');
      var spinEl = stage.querySelector('[data-tilt]');
      var angle = 0, target = 0, timer = null, touched = false, anim = null;
      var dragging = false, startX = 0, startAngle = 0, lastX = 0, lastT = 0, vel = 0, moved = 0;

      function norm(d) { d = ((d % 360) + 360) % 360; return d > 180 ? d - 360 : d; }
      function setAngle(a) {
        angle = a;
        var best = null, bestAbs = 999;
        faces.forEach(function (f) {
          var rel = norm(a - (parseFloat(f.dataset.angle) || 0)), ab = Math.abs(rel);
          if (ab < bestAbs) { bestAbs = ab; best = f; }
          var op = Math.max(0, Math.min(1, 1 - (ab - 30) / 22));
          f.style.opacity = op.toFixed(3);
          f.style.transform = op > 0 ? 'rotateY(' + (rel * 0.55).toFixed(2) + 'deg) scale(' + (1 - Math.min(ab, 60) / 600).toFixed(3) + ')' : '';
          f.style.visibility = op > 0 ? 'visible' : 'hidden';
        });
        faces.forEach(function (f) { f.classList.toggle('is-active', f === best && bestAbs < 26); });
        var view = best ? best.dataset.face : 'front';
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.view === view ? 'true' : 'false'); });
      }
      function tweenTo(to, ms) {
        cancelAnimationFrame(anim);
        if (reduce) { setAngle(to); return; }
        var from = angle, t0 = performance.now();
        ms = ms || 900;
        stage.classList.add('is-spinning');
        (function step(now) {
          var p = Math.min(1, (now - t0) / ms);
          var e = 1 - Math.pow(1 - p, 4);
          setAngle(from + (to - from) * e);
          if (p < 1) anim = requestAnimationFrame(step);
          else stage.classList.remove('is-spinning');
        })(t0);
      }
      function snap(a) { return Math.round(a / 90) * 90; }
      function show(view) {
        var f = stage.querySelector('[data-face="' + view + '"]'); if (!f) return;
        var target = angle + norm((parseFloat(f.dataset.angle) || 0) - angle);
        tweenTo(target, 500 + Math.abs(target - angle) * 5);
      }
      function userTurned() { touched = true; stop(); stage.classList.add('is-turned'); }
      buttons.forEach(function (b) {
        b.addEventListener('click', function () { userTurned(); show(b.dataset.view); });
      });

      function start() { if (reduce || touched || timer) return; timer = setInterval(function () { tweenTo(snap(angle) + 90, 1500); }, 4200); }
      function stop() { clearInterval(timer); timer = null; }
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
        }, { threshold: 0.35 }).observe(stage);
      }

      if (stage.hasAttribute('data-spin')) {
        stage.addEventListener('pointerdown', function (e) {
          if (e.button !== 0 || e.target.closest('button, a, input')) return;
          dragging = true; moved = 0; vel = 0;
          startX = lastX = e.clientX; lastT = performance.now();
          startAngle = angle;
          cancelAnimationFrame(anim);
          stage.classList.add('is-dragging');
          try { stage.setPointerCapture(e.pointerId); } catch (err) {}
        });
        stage.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var now = performance.now();
          var dx = e.clientX - startX;
          moved = Math.max(moved, Math.abs(dx));
          if (moved > 4 && !touched) userTurned();
          var w = stage.getBoundingClientRect().width || 400;
          setAngle(startAngle + dx / w * 260);
          var dt = Math.max(1, now - lastT);
          vel = vel * 0.6 + ((e.clientX - lastX) / w * 260 / dt) * 0.4;
          lastX = e.clientX; lastT = now;
        });
        function release() {
          if (!dragging) return;
          dragging = false;
          stage.classList.remove('is-dragging');
          if (moved < 4) return;
          var projected = angle + vel * 260;
          var to = snap(projected);
          if (to === snap(startAngle) && Math.abs(angle - startAngle) > 30) to = snap(startAngle) + (angle > startAngle ? 90 : -90);
          var turns = Math.abs(to - angle) / 90;
          tweenTo(to, 600 + Math.min(turns, 4) * 260);
          if (window.saSound && Math.abs(to - startAngle) >= 90) window.saSound('turn');
        }
        stage.addEventListener('pointerup', release);
        stage.addEventListener('pointercancel', release);
        stage.addEventListener('lostpointercapture', release);
      }

      if (finePointer && !reduce && spinEl) {
        stage.addEventListener('pointermove', function (e) {
          if (dragging) return;
          var r = stage.getBoundingClientRect();
          var x = (e.clientX - r.left) / r.width - 0.5;
          var y = (e.clientY - r.top) / r.height - 0.5;
          spinEl.style.setProperty('--rx', (x * 14).toFixed(2) + 'deg');
          spinEl.style.setProperty('--ry', (y * -9).toFixed(2) + 'deg');
        });
        stage.addEventListener('pointerleave', function () {
          spinEl.style.setProperty('--rx', '0deg');
          spinEl.style.setProperty('--ry', '0deg');
        });
      }
      setAngle(0);
    });
  }

  /* Optional launch countdown */
  function initCountdown(root) {
    (root || document).querySelectorAll('[data-countdown]').forEach(function (box) {
      var target = Date.parse(box.dataset.countdown);
      if (isNaN(target)) return;
      var units = {
        days: box.querySelector('[data-unit="days"]'),
        hours: box.querySelector('[data-unit="hours"]'),
        minutes: box.querySelector('[data-unit="minutes"]'),
        seconds: box.querySelector('[data-unit="seconds"]')
      };
      function pad(n) { return (n < 10 ? '0' : '') + n; }
      function tick() {
        var ms = Math.max(0, target - Date.now());
        var s = Math.floor(ms / 1000);
        units.days.textContent = pad(Math.floor(s / 86400));
        units.hours.textContent = pad(Math.floor(s % 86400 / 3600));
        units.minutes.textContent = pad(Math.floor(s % 3600 / 60));
        units.seconds.textContent = pad(s % 60);
        if (ms <= 0) clearInterval(t);
      }
      box.hidden = false;
      tick();
      var t = setInterval(tick, 1000);
    });
  }


  /* ======================================================================
     Signature motion
     ====================================================================== */

  /* Opening heartbeat plays once per session */
  function markSeen() { try { sessionStorage.setItem('sa-seen', '1'); } catch (e) {} }

  /* Scroll progress line */
  function initProgress() {
    var bar = document.querySelector('.sa-progress');
    if (!bar || reduce) return;
    var tick = false;
    function update() {
      tick = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--sp', max > 0 ? (window.scrollY / max).toFixed(4) : 0);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Live heartbeat monitor: sweeps like a bedside monitor, beats on its own,
     and quickens when someone types their email or hovers the button. */
  var monitors = [];
  function beatShape(t) {
    // t in [0,1] across one beat; returns vertical offset (-1..1)
    if (t < .10) return Math.sin(t / .10 * Math.PI) * .08;                 // P wave
    if (t < .16) return 0;
    if (t < .19) return (t - .16) / .03 * .18;                              // Q
    if (t < .23) return .18 - (t - .19) / .04 * 1.18;                       // R up
    if (t < .28) return -1 + (t - .23) / .05 * 1.45;                        // S down
    if (t < .32) return .45 - (t - .28) / .04 * .45;
    if (t < .45) return 0;
    if (t < .62) return -Math.sin((t - .45) / .17 * Math.PI) * .22;        // T wave
    return 0;
  }
  function initMonitor(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-monitor]').forEach(function (m) {
      if (m.dataset.ready) return; m.dataset.ready = '1';
      var cv = m.querySelector('canvas'); if (!cv || !cv.getContext) return;
      var ctx = cv.getContext('2d');
      var bpmEl = m.querySelector('[data-bpm]'), heart = m.querySelector('.sa-monitor__heart');
      var st = { x: 0, lastY: null, beatT: -1, beatLen: 70, since: 0, rest: 60, beats: [], visible: true };
      var dpr = Math.min(window.devicePixelRatio || 1, 2), W = 0, H = 0;
      function size() {
        var r = m.getBoundingClientRect();
        W = Math.max(1, Math.round(r.width)); H = Math.max(1, Math.round(r.height));
        cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        ctx.clearRect(0, 0, W, H); st.x = 0; st.lastY = null;
      }
      size(); window.addEventListener('resize', size);
      m.classList.add('is-live');
      var glow = getComputedStyle(document.documentElement).getPropertyValue('--sa-glow').trim() || '#2E6FC6';

      function trigger() {
        if (st.beatT >= 0 && st.beatT < .5) return;
        st.beatT = 0;
        var now = performance.now();
        st.beats.push(now); st.beats = st.beats.filter(function (b) { return now - b < 6000; });
        if (st.beats.length > 1) {
          var span = (st.beats[st.beats.length - 1] - st.beats[0]) / (st.beats.length - 1);
          var bpm = Math.round(Math.max(48, Math.min(180, 60000 / span)));
          if (bpmEl) bpmEl.textContent = bpm;
        }
        if (heart) { heart.classList.remove('is-beat'); void heart.offsetWidth; heart.classList.add('is-beat'); }
        if (window.saSound) window.saSound('beat');
      }
      m.saTrigger = trigger;
      monitors.push(m);

      var excite = 0;
      function frame() {
        if (!st.visible) { requestAnimationFrame(frame); return; }
        var speed = 2.2;
        for (var k = 0; k < 2; k++) {
          st.since += 1;
          var interval = 64 - excite * 26;
          if (st.since > interval) { st.since = 0; trigger(); }
          var y = 0;
          if (st.beatT >= 0) {
            y = beatShape(st.beatT);
            st.beatT += 1 / st.beatLen;
            if (st.beatT >= 1) st.beatT = -1;
          }
          var py = H / 2 - y * (H * .42);
          var nx = st.x + speed / 2;
          ctx.clearRect(st.x + 1, 0, 26, H);
          if (st.lastY !== null) {
            ctx.strokeStyle = glow; ctx.lineWidth = 1.6; ctx.lineCap = 'round';
            ctx.shadowColor = glow; ctx.shadowBlur = 8;
            ctx.beginPath(); ctx.moveTo(st.x, st.lastY); ctx.lineTo(nx, py); ctx.stroke();
          }
          st.x = nx; st.lastY = py;
          if (st.x > W) { st.x = 0; st.lastY = null; }
        }
        // fade old trace slightly so the sweep reads as a monitor
        ctx.save(); ctx.globalCompositeOperation = 'destination-out'; ctx.fillStyle = 'rgba(0,0,0,.012)'; ctx.fillRect(0, 0, W, H); ctx.restore();
        excite = Math.max(0, excite - .004);
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { st.visible = e[0].isIntersecting; }).observe(m);

      // Typing in any email field makes the heart beat with each keystroke
      document.addEventListener('input', function (e) {
        if (e.target && e.target.type === 'email') { excite = Math.min(1, excite + .25); trigger(); }
      });
      document.querySelectorAll('.sa-signup .sa-button').forEach(function (b) {
        b.addEventListener('pointerenter', function () { excite = 1; });
      });
    });
  }

  /* Balloons: tap one to let it go */
  function initSky(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-sky]').forEach(function (sky) {
      if (sky.dataset.ready) return; sky.dataset.ready = '1';
      sky.addEventListener('pointerdown', function (e) {
        var b = e.target.closest('.sa-balloon'); if (!b || b.classList.contains('is-released')) return;
        var a = b.getAnimations ? b.getAnimations()[0] : null;
        if (a) a.playbackRate = 7;
        b.classList.add('is-released');
        monitors.forEach(function (m) { m.saTrigger && m.saTrigger(); });
        setTimeout(function () { if (a) a.playbackRate = 1; b.classList.remove('is-released'); }, 3600);
      });
    });
  }

  /* Headings arrive letter by letter */
  var charIndex = 0;
  function splitInto(node, text, start) {
    var i = start;
    text.split(/(\s+)/).forEach(function (part) {
      if (!part) return;
      if (/^\s+$/.test(part)) { node.appendChild(document.createTextNode(' ')); return; }
      var w = document.createElement('span'); w.className = 'sa-word-wrap'; w.setAttribute('aria-hidden', 'true');
      for (var k = 0; k < part.length; k++) {
        var c = document.createElement('span'); c.className = 'sa-char'; c.style.setProperty('--c', i++); c.textContent = part[k]; w.appendChild(c);
      }
      node.appendChild(w);
    });
    return i;
  }
  function splitChars(el) {
    if (el.dataset.chars) return; el.dataset.chars = '1';
    el.setAttribute('aria-label', el.textContent.replace(/\s+/g, ' ').trim());
    var kids = Array.prototype.slice.call(el.children);
    if (kids.length && kids.every(function (k) { return k.children.length === 0; })) {
      var i = 0;
      kids.forEach(function (k) { var t = k.textContent.trim(); k.textContent = ''; i = splitInto(k, t, i); });
      return;
    }
    var text = el.textContent; el.textContent = '';
    splitInto(el, text, 0);
  }
  function initChars(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-reveal] .sa-display').forEach(splitChars);
  }

  /* The jacket unzips into view */
  function initZip(root) {
    (root || document).querySelectorAll('[data-zip]').forEach(function (z) {
      if (reduce || !('IntersectionObserver' in window)) { z.classList.add('is-open'); return; }
      var io = new IntersectionObserver(function (e) {
        if (e[0].isIntersecting) { z.classList.add('is-open'); io.disconnect(); }
      }, { threshold: 0.45 });
      io.observe(z);
    });
  }

  /* Soft light follows the cursor across dark sections */
  function initSpotlight(root) {
    if (reduce || !finePointer) return;
    (root || document).querySelectorAll('[data-spotlight]').forEach(function (s) {
      s.addEventListener('pointermove', function (e) {
        var r = s.getBoundingClientRect();
        s.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        s.style.setProperty('--my', (e.clientY - r.top) + 'px');
        s.classList.add('is-lit');
      });
      s.addEventListener('pointerleave', function () { s.classList.remove('is-lit'); });
    });
  }

  /* Buttons lean toward the cursor */
  function initMagnets(root) {
    if (reduce || !finePointer) return;
    (root || document).querySelectorAll('.sa-button, .sa-header__cta').forEach(function (b) {
      if (b.dataset.mag) return; b.dataset.mag = '1';
      b.addEventListener('pointermove', function (e) {
        var r = b.getBoundingClientRect();
        b.style.setProperty('--tx', ((e.clientX - r.left - r.width / 2) * .22).toFixed(1) + 'px');
        b.style.setProperty('--ty', ((e.clientY - r.top - r.height / 2) * .3).toFixed(1) + 'px');
      });
      b.addEventListener('pointerleave', function () { b.style.setProperty('--tx', '0px'); b.style.setProperty('--ty', '0px'); });
    });
  }

  /* Close-ups drift slightly against the scroll */
  var frames = [];
  function initParallax(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-parallax]').forEach(function (f) { frames.push(f); });
    updateParallax();
  }
  function updateParallax() {
    var vh = window.innerHeight;
    frames.forEach(function (f) {
      var r = f.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      f.style.setProperty('--py', (p * -26).toFixed(1) + 'px');
    });
  }
  var pTick = false;
  window.addEventListener('scroll', function () {
    if (!frames.length || pTick) return; pTick = true;
    requestAnimationFrame(function () { pTick = false; updateParallax(); });
  }, { passive: true });

  /* A burst of balloons when someone joins the list */
  function burst(fromEl) {
    if (reduce || !document.body.animate) return;
    var r = fromEl ? fromEl.getBoundingClientRect() : { left: innerWidth / 2, top: innerHeight / 2, width: 0, height: 0 };
    var ox = r.left + r.width / 2, oy = r.top + r.height / 2;
    var colors = ['#2E6FC6', '#5E9BE6', '#9CC6F5', '#173F7C', '#FFFFFF', '#C9DFF8'];
    for (var i = 0; i < 22; i++) {
      var b = document.createElement('span');
      b.className = 'sa-pop';
      b.style.setProperty('--c', colors[i % colors.length]);
      b.style.left = ox + 'px'; b.style.top = oy + 'px';
      document.body.appendChild(b);
      var dx = (Math.random() - .5) * Math.min(innerWidth, 900);
      var up = innerHeight * (.7 + Math.random() * .6);
      var sc = .6 + Math.random() * .8, rot = (Math.random() - .5) * 40;
      var anim = b.animate([
        { transform: 'translate(0,0) scale(.2) rotate(0deg)', opacity: 0 },
        { transform: 'translate(' + dx * .35 + 'px,' + (-up * .25) + 'px) scale(' + sc + ') rotate(' + rot / 2 + 'deg)', opacity: 1, offset: .2 },
        { transform: 'translate(' + dx + 'px,' + (-up) + 'px) scale(' + sc + ') rotate(' + rot + 'deg)', opacity: 0 }
      ], { duration: 2600 + Math.random() * 1600, delay: Math.random() * 260, easing: 'cubic-bezier(.2,.6,.3,1)', fill: 'forwards' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(b);
    }
    monitors.forEach(function (m) { m.saTrigger && m.saTrigger(); });
    if (window.saSound) window.saSound('chime');
  }
  window.saBurst = burst;
  /* Heartbeat sound: synthesized, off by default, only starts after a click */
  (function () {
    var AC = window.AudioContext || window.webkitAudioContext;
    var on = false, ctx = null, master = null, lastBeat = 0;
    function store(v) { try { localStorage.setItem('sa-sound', v ? '1' : '0'); } catch (e) {} }
    function stored() { try { return localStorage.getItem('sa-sound') === '1'; } catch (e) { return false; } }
    function ensure() {
      if (!AC) return false;
      if (!ctx) {
        ctx = new AC();
        master = ctx.createGain(); master.gain.value = 0.9;
        var lp = ctx.createBiquadFilter(); lp.type = 'lowpass'; lp.frequency.value = 900;
        master.connect(lp); lp.connect(ctx.destination);
      }
      if (ctx.state === 'suspended') ctx.resume();
      return true;
    }
    function thump(t, f, vol) {
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'sine';
      o.frequency.setValueAtTime(f, t);
      o.frequency.exponentialRampToValueAtTime(f * 0.45, t + 0.16);
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(vol, t + 0.012);
      g.gain.exponentialRampToValueAtTime(0.0001, t + 0.22);
      o.connect(g); g.connect(master); o.start(t); o.stop(t + 0.25);
    }
    function tone(t, f, vol, len) {
      var o = ctx.createOscillator(), g = ctx.createGain();
      o.type = 'triangle'; o.frequency.value = f;
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(vol, t + 0.02);
      g.gain.exponentialRampToValueAtTime(0.0001, t + len);
      o.connect(g); g.connect(ctx.destination); o.start(t); o.stop(t + len + 0.05);
    }
    window.saSound = function (kind) {
      if (!on || !ctx || document.hidden) return;
      var t = ctx.currentTime + 0.01;
      if (kind === 'beat') {
        var now = performance.now(); if (now - lastBeat < 350) return; lastBeat = now;
        thump(t, 62, 0.55); thump(t + 0.17, 54, 0.38);
      } else if (kind === 'chime') {
        [523.25, 659.25, 783.99, 1046.5].forEach(function (f, i) { tone(t + i * 0.09, f, 0.06, 1.2); });
      } else if (kind === 'turn') {
        tone(t, 196, 0.035, 0.5);
      }
    };
    function sync() {
      document.querySelectorAll('[data-sound-toggle]').forEach(function (b) {
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.setAttribute('aria-label', on ? 'Turn heartbeat sound off' : 'Turn heartbeat sound on');
      });
    }
    function initSound(root) {
      if (!AC) return;
      (root || document).querySelectorAll('[data-sound-toggle]').forEach(function (b) {
        if (b.dataset.ready) return; b.dataset.ready = '1';
        b.hidden = false;
        if (stored()) b.classList.add('is-remembered');
        b.addEventListener('click', function () {
          on = !on;
          if (on && !ensure()) { on = false; return; }
          store(on); sync();
          if (on) window.saSound('beat');
        });
      });
      sync();
    }
    window.saInitSound = initSound;
  })();

  /* Several email forms share one Shopify "posted" state: only the one that was sent shows success */
  var FORM_KEY = 'sa-form-sent';
  function initForms() {
    document.addEventListener('submit', function (e) {
      var f = e.target;
      if (!f || !f.id || !f.querySelector('[name="contact[email]"]')) return;
      try { sessionStorage.setItem(FORM_KEY, f.id); } catch (err) {}
    }, true);
    var sent = null;
    try { sent = sessionStorage.getItem(FORM_KEY); sessionStorage.removeItem(FORM_KEY); } catch (err) {}
    var hash = (location.hash || '').replace('#', '');
    if (!sent && hash && document.getElementById(hash)) sent = hash;
    if (!sent) return;
    document.querySelectorAll('form').forEach(function (f) {
      if (f.id === sent) return;
      f.querySelectorAll('[data-sa-success], [data-sa-error], .sa-signup__error-detail').forEach(function (el) { el.remove(); });
      var fields = f.querySelector('[data-sa-fields]'); if (fields) fields.hidden = false;
      var em = f.querySelector('[name="contact[email]"]'); if (em) { em.value = ''; em.removeAttribute('aria-invalid'); }
    });
  }
  function initBurst() {
    var ok = Array.prototype.filter.call(document.querySelectorAll('.sa-signup__success'), function (el) { return el.offsetParent !== null; })[0];
    if (ok) setTimeout(function () { ok.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); burst(ok); }, 500);
  }


  /* ---------- Flashlight over hidden messages ---------- */
  function initFlashlight(root) {
    (root || document).querySelectorAll('[data-flashlight]').forEach(function (panel) {
      if (panel.dataset.ready) return; panel.dataset.ready = '1';
      var tx = 30, ty = 40, cx = 30, cy = 40, lastMove = -1e9, visible = false, t0 = performance.now();
      function setFromEvent(e) {
        var r = panel.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width * 100; ty = (e.clientY - r.top) / r.height * 100;
        lastMove = performance.now(); panel.classList.add('is-touched');
      }
      panel.addEventListener('pointermove', setFromEvent);
      panel.addEventListener('pointerdown', setFromEvent);
      if (reduce) { panel.style.setProperty('--lx', '50%'); panel.style.setProperty('--ly', '50%'); return; }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { visible = e[0].isIntersecting; if (visible) loop(); }).observe(panel);
      function loop() {
        if (!visible) return;
        var now = performance.now();
        if (now - lastMove > 2200) {
          // wander slowly between the hidden messages when nobody is steering
          var t = (now - t0) / 1000;
          tx = 50 + Math.sin(t * .42) * 32 + Math.sin(t * .17) * 8;
          ty = 50 + Math.sin(t * .31 + 1.2) * 26;
        }
        cx += (tx - cx) * .08; cy += (ty - cy) * .08;
        panel.style.setProperty('--lx', cx.toFixed(2) + '%');
        panel.style.setProperty('--ly', cy.toFixed(2) + '%');
        requestAnimationFrame(loop);
      }
    });
  }

  /* ---------- Hotspots: tap to show, tap again to hide ---------- */
  function initHotspots(root) {
    (root || document).querySelectorAll('[data-hot]').forEach(function (h) {
      if (h.dataset.ready) return; h.dataset.ready = '1';
      h.addEventListener('click', function (e) {
        e.stopPropagation();
        var on = !h.classList.contains('is-on');
        document.querySelectorAll('[data-hot].is-on').forEach(function (o) { o.classList.remove('is-on'); });
        h.classList.toggle('is-on', on);
        monitors.forEach(function (m) { m.saTrigger && m.saTrigger(); });
      });
    });
    document.addEventListener('click', function () {
      document.querySelectorAll('[data-hot].is-on').forEach(function (o) { o.classList.remove('is-on'); });
    });
  }

  /* ---------- Heart cursor (mouse only) ---------- */
  function initCursor() {
    var c = document.querySelector('.sa-cursor');
    if (!c || reduce || !finePointer) return;
    var mx = -100, my = -100, rx = -100, ry = -100, shown = false;
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse') return;
      mx = e.clientX; my = e.clientY;
      if (!shown) { shown = true; rx = mx; ry = my; c.classList.add('is-on'); requestAnimationFrame(loop); }
      var hot = e.target.closest && e.target.closest('a, button, input, [data-hot], .sa-balloon, [data-flashlight]');
      c.classList.toggle('is-hover', !!hot);
      c.style.setProperty('--hs', hot ? 1 : 0);
    });
    document.addEventListener('pointerleave', function () { c.classList.remove('is-on'); shown = false; });
    function loop() {
      if (!shown) return;
      rx += (mx - rx) * .18; ry += (my - ry) * .18;
      c.style.setProperty('--cx', rx.toFixed(1) + 'px'); c.style.setProperty('--cy', ry.toFixed(1) + 'px');
      c.style.setProperty('--dx', mx + 'px'); c.style.setProperty('--dy', my + 'px');
      requestAnimationFrame(loop);
    }
  }

  /* ---------- Ticker speeds up and reverses with your scrolling ---------- */
  function initMarquee(root) {
    if (reduce) return;
    var tracks = [].slice.call((root || document).querySelectorAll('.sa-marquee__track'));
    if (!tracks.length || !tracks[0].getAnimations) return;
    var lastY = window.scrollY, vel = 0, dir = 1;
    window.addEventListener('scroll', function () {
      var dy = window.scrollY - lastY; lastY = window.scrollY;
      vel = Math.max(-60, Math.min(60, dy));
      if (dy) dir = dy > 0 ? 1 : -1;
    }, { passive: true });
    (function loop() {
      vel *= .9;
      var rate = dir * (1 + Math.abs(vel) * .12);
      tracks.forEach(function (t) { var a = t.getAnimations()[0]; if (a) a.playbackRate = rate; });
      requestAnimationFrame(loop);
    })();
  }

  /* ---------- Send to someone ---------- */
  function initShare(root) {
    (root || document).querySelectorAll('[data-share]').forEach(function (b) {
      if (b.dataset.ready) return; b.dataset.ready = '1';
      var status = b.parentNode.querySelector('[data-share-status]');
      b.addEventListener('click', function () {
        var url = location.origin + '/';
        var text = b.dataset.shareText || document.title;
        function say(t) { if (status) status.textContent = t; }
        if (navigator.share) {
          navigator.share({ title: document.title, text: text, url: url }).then(function () { say('Sent.'); }, function () {});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(text + ' ' + url).then(function () { say('Link copied. Paste it to them.'); }, function () { say(url); });
        } else { say(url); }
      });
    });
  }

  /* ---------- A note in the tab when someone looks away ---------- */
  function initTabTitle() {
    var original = document.title, away = 'come back… i think the world of you';
    document.addEventListener('visibilitychange', function () {
      document.title = document.hidden ? away : original;
    });
  }


  /* ======================================================================
     Product page
     ====================================================================== */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-pdp]').forEach(function (pdp) {
      if (pdp.dataset.ready) return; pdp.dataset.ready = '1';
      var variants = [];
      try { variants = JSON.parse(pdp.querySelector('[data-variants]').textContent); } catch (e) {}
      var form = pdp.querySelector('[data-pdp-form]');
      var idInput = pdp.querySelector('[data-variant-id]');
      var addBtn = pdp.querySelector('[data-add]'), addLabel = pdp.querySelector('[data-add-label]');
      var addText = addLabel ? addLabel.textContent.trim() : 'Add to bag';
      if (addText === 'Sold out') addText = (pdp.querySelector('[data-bar-add]') || {}).textContent || 'Add to bag';
      var status = pdp.querySelector('[data-add-status]');
      var waitlist = pdp.querySelector('[data-waitlist]');
      var bar = pdp.querySelector('[data-bar]'), barAdd = pdp.querySelector('[data-bar-add]');

      /* Gallery */
      var slides = pdp.querySelectorAll('[data-slide]'), thumbs = pdp.querySelectorAll('[data-thumb]');
      var stage = pdp.querySelector('[data-zoom]'), cur = 0;
      function go(i) {
        if (!slides.length) return;
        cur = (i + slides.length) % slides.length;
        slides.forEach(function (sl, k) { sl.classList.toggle('is-active', k === cur); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === cur); });
        stage && stage.classList.remove('is-zoom');
      }
      thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.dataset.thumb); }); });
      if (stage) {
        if (finePointer) {
          stage.addEventListener('click', function () { stage.classList.toggle('is-zoom'); });
          stage.addEventListener('pointermove', function (e) {
            var r = stage.getBoundingClientRect();
            var img = slides[cur] && slides[cur].querySelector('img');
            if (img) { img.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%'); img.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%'); }
          });
          stage.addEventListener('pointerleave', function () { stage.classList.remove('is-zoom'); });
        }
        // swipe on phones
        var sx = null;
        stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx; sx = null;
          if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
        });
      }

      /* Variant picking */
      function selected() {
        var vals = [];
        pdp.querySelectorAll('[data-option-index]').forEach(function (fs) {
          var c = fs.querySelector('input:checked'); vals.push(c ? c.value : null);
        });
        return vals;
      }
      function findVariant(vals) {
        for (var i = 0; i < variants.length; i++) {
          var ok = true;
          for (var k = 0; k < vals.length; k++) if (variants[i].options[k] !== vals[k]) { ok = false; break; }
          if (ok) return variants[i];
        }
        return null;
      }
      function markAvailability() {
        var vals = selected();
        pdp.querySelectorAll('[data-option]').forEach(function (inp) {
          var k = +inp.dataset.option, test = vals.slice(); test[k] = inp.value;
          var v = findVariant(test);
          inp.closest('.sa-pill').classList.toggle('is-unavailable', !v || !v.available);
        });
      }
      function update() {
        var vals = selected();
        pdp.querySelectorAll('[data-option-label]').forEach(function (l) { l.textContent = vals[+l.dataset.optionLabel] || ''; });
        var v = findVariant(vals);
        if (!v) { addBtn.disabled = true; addLabel.textContent = 'Unavailable'; return; }
        idInput.value = v.id;
        var price = pdp.querySelector('[data-price]'), cmp = pdp.querySelector('[data-compare]');
        price.textContent = v.price;
        if (cmp) { cmp.hidden = !v.compare; cmp.textContent = v.compare || ''; }
        addBtn.disabled = !v.available; addLabel.textContent = v.available ? addText : 'Sold out';
        if (barAdd) { barAdd.disabled = !v.available; barAdd.textContent = v.available ? addText : 'Sold out'; }
        var bv = pdp.querySelector('[data-bar-variant]'), bp = pdp.querySelector('[data-bar-price]');
        if (bv) bv.textContent = v.title === 'Default Title' ? '' : v.title;
        if (bp) bp.textContent = v.price;
        if (waitlist) waitlist.hidden = v.available;
        if (v.media) {
          var sl = pdp.querySelector('[data-media-id="' + v.media + '"]');
          if (sl) go(+sl.dataset.slide);
        }
        markAvailability();
        highlightSize(vals);
        try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); } catch (e) {}
      }
      pdp.querySelectorAll('[data-option]').forEach(function (inp) { inp.addEventListener('change', update); });
      markAvailability();

      /* Add to bag without leaving the page (falls back to a normal submit) */
      function say(html) { if (status) status.innerHTML = html; }
      if (form && window.fetch && window.FormData) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (addBtn.disabled) return;
          addBtn.classList.add('is-busy'); say('Adding…');
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
            .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
            .then(function () {
              say('Added to your bag. <a href="' + root + 'cart">View bag →</a>');
              if (window.saCart) window.saCart.added();
              if (window.saBurst && !reduce) window.saBurst(addBtn);
            })
            .catch(function (err) {
              say((err && (err.description || err.message)) || 'That didn’t work. Please try again.');
            })
            .then(function () { addBtn.classList.remove('is-busy'); });
        });
      }

      /* Sticky bar on phones: show once the main button scrolls away */
      if (bar && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (e) {
          var on = !e[0].isIntersecting && e[0].boundingClientRect.top < 0;
          bar.classList.toggle('is-on', on);
          bar.setAttribute('aria-hidden', on ? 'false' : 'true');
          if (barAdd) barAdd.tabIndex = on ? 0 : -1;
        }).observe(addBtn);
        if (barAdd) barAdd.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
          addBtn.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' });
        });
      }

      /* Size chart */
      var dlg = pdp.querySelector('[data-sizes]');
      function highlightSize(vals) {
        if (!dlg) return;
        dlg.querySelectorAll('tbody tr').forEach(function (tr) {
          var s = tr.querySelector('th').textContent.trim();
          tr.classList.toggle('is-picked', vals.indexOf(s) !== -1);
        });
      }
      highlightSize(selected());
      pdp.querySelectorAll('[data-open-sizes]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (dlg && dlg.showModal) dlg.showModal(); else if (dlg) dlg.setAttribute('open', '');
        });
      });
      if (dlg) {
        dlg.querySelectorAll('[data-close-sizes]').forEach(function (b) { b.addEventListener('click', function () { dlg.close ? dlg.close() : dlg.removeAttribute('open'); }); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
      }
    });
  }


  /* Dedication card: live preview, then drawn to a canvas and shared or saved as a PNG */
  function initDedicate(root) {
    (root || document).querySelectorAll('[data-dedicate]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var form = sec.querySelector('[data-dedicate-form]');
      var nameIn = sec.querySelector('[data-dedicate-name]');
      var fromIn = sec.querySelector('[data-dedicate-from]');
      var out = sec.querySelector('[data-dedicate-out]');
      var fromOut = sec.querySelector('[data-dedicate-from-out]');
      var status = sec.querySelector('[data-dedicate-status]');
      var logo = sec.querySelector('[data-dedicate-logo]');
      var lead = (sec.querySelector('.sa-dcard__lead') || {}).textContent || 'i think the world of';
      var domain = (sec.querySelector('.sa-dcard__url') || {}).textContent || '';
      var fallback = out ? out.textContent : 'you';
      if (!form || !nameIn || !out) return;

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (e) { sec.classList.toggle('is-in', e[0].isIntersecting); }, { threshold: .25 });
        io.observe(sec);
      } else sec.classList.add('is-in');

      function clean(v) { return (v || '').replace(/\s+/g, ' ').trim().slice(0, 24); }
      var popT;
      function update() {
        var n = clean(nameIn.value) || fallback;
        if (nameIn.classList.contains('sa-know__input')) nameIn.style.width = Math.max(4, (nameIn.value || nameIn.placeholder || '').length * .92 + 1.2).toFixed(1) + 'ch';
        out.textContent = n;
        out.classList.toggle('is-long', n.length > 11);
        var f = clean(fromIn && fromIn.value);
        if (fromOut) { fromOut.hidden = !f; fromOut.textContent = f ? '\u2014 ' + f : ''; }
        if (!reduce) { clearTimeout(popT); popT = setTimeout(function () { out.classList.remove('is-pop'); void out.offsetWidth; out.classList.add('is-pop'); }, 220); }
        if (status) status.textContent = '';
      }
      nameIn.addEventListener('input', update);
      if (nameIn.classList.contains('sa-know__input')) nameIn.style.width = Math.max(4, (nameIn.placeholder || '').length * .92 + 1.2).toFixed(1) + 'ch';
      if (fromIn) fromIn.addEventListener('input', update);

      function loadImg(src) {
        return new Promise(function (res) {
          var im = new Image(); im.crossOrigin = 'anonymous';
          im.onload = function () { res(im); }; im.onerror = function () { res(null); };
          im.src = src;
        });
      }
      function draw(withLogo) {
        var W = 1080, H = 1920;
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H;
        var c = cv.getContext('2d');
        var ink = '#173F7C', bone = '#F4F9FF', glow = '#B5D5F9', rgb = '181,213,249';
        var sky = c.createLinearGradient(0, 0, 0, H);
        sky.addColorStop(0, '#2F6DC0'); sky.addColorStop(.55, '#1D4C93'); sky.addColorStop(1, '#143A75');
        c.fillStyle = sky; c.fillRect(0, 0, W, H);
        var g = c.createRadialGradient(W / 2, H * .47, 0, W / 2, H * .47, W * .75);
        g.addColorStop(0, 'rgba(' + rgb + ',.22)'); g.addColorStop(1, 'rgba(' + rgb + ',0)');
        c.fillStyle = g; c.fillRect(0, 0, W, H);
        c.textAlign = 'center'; c.textBaseline = 'alphabetic';
        var y = 520;
        if (withLogo) {
          var lw = 500, lh = lw * withLogo.naturalHeight / withLogo.naturalWidth;
          c.drawImage(withLogo, (W - lw) / 2, 250, lw, lh); y = 250 + lh + 170;
        }
        c.fillStyle = 'rgba(244,249,255,.6)';
        c.font = '400 34px "IBM Plex Mono", monospace';
        if ('letterSpacing' in c) c.letterSpacing = '7px';
        c.fillText(lead.trim().toLowerCase(), W / 2, y);
        if ('letterSpacing' in c) c.letterSpacing = '0px';
        var name = out.textContent;
        var size = 190;
        c.font = 'italic 300 ' + size + 'px "Cormorant Garamond", serif';
        while (c.measureText(name).width > W * .84 && size > 70) { size -= 6; c.font = 'italic 300 ' + size + 'px "Cormorant Garamond", serif'; }
        c.save(); c.shadowColor = 'rgba(' + rgb + ',.55)'; c.shadowBlur = 60; c.fillStyle = bone;
        c.fillText(name, W / 2, y + 90 + size * .8); c.restore();
        var ey = y + 90 + size * .8 + 150;
        c.save(); c.strokeStyle = glow; c.lineWidth = 5; c.lineJoin = c.lineCap = 'round';
        c.shadowColor = 'rgba(' + rgb + ',.9)'; c.shadowBlur = 18;
        var pts = [[0,20],[110,20],[118,20],[124,8],[130,32],[138,2],[146,36],[152,20],[300,20]];
        var sx = W * .78 / 300, ox = W * .11;
        c.beginPath(); pts.forEach(function (p, i) { var px = ox + p[0] * sx, py = ey + (p[1] - 20) * sx; i ? c.lineTo(px, py) : c.moveTo(px, py); });
        c.stroke(); c.restore();
        c.fillStyle = bone; c.font = 'italic 400 64px "Cormorant Garamond", serif';
        c.fillText('proof you were here.', W / 2, ey + 190);
        var f = fromOut && !fromOut.hidden ? fromOut.textContent : '';
        if (f) { c.fillStyle = 'rgba(244,249,255,.6)'; c.font = '400 30px "IBM Plex Mono", monospace'; c.fillText(f, W / 2, ey + 270); }
        c.fillStyle = 'rgba(244,249,255,.4)'; c.font = '400 24px "IBM Plex Mono", monospace';
        if ('letterSpacing' in c) c.letterSpacing = '6px';
        c.fillText(domain.trim().toUpperCase(), W / 2, H - 110);
        return cv;
      }
      function toBlob(cv) {
        return new Promise(function (res) { try { cv.toBlob(function (b) { res(b); }, 'image/png'); } catch (e) { res(null); } });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (status) status.textContent = 'Making your card…';
        var fontsReady = document.fonts && document.fonts.load ? Promise.all([
          document.fonts.load('italic 300 100px "Cormorant Garamond"'),
          document.fonts.load('italic 400 64px "Cormorant Garamond"'),
          document.fonts.load('400 30px "IBM Plex Mono"')
        ]).catch(function () {}) : Promise.resolve();
        fontsReady.then(function () { return logo ? loadImg(logo.currentSrc || logo.src) : null; })
          .then(function (im) {
            return toBlob(draw(im)).then(function (b) { return b || toBlob(draw(null)); });
          })
          .then(function (blob) {
            if (!blob) { if (status) status.textContent = 'Sorry, this browser could not make the image.'; return; }
            var file = (clean(nameIn.value) || 'you').replace(/[^\w-]+/g, '-').toLowerCase();
            var fname = 'sans-armure-' + file + '.png';
            var fileObj = null;
            try { fileObj = new File([blob], fname, { type: 'image/png' }); } catch (err) {}
            if (fileObj && navigator.canShare && navigator.canShare({ files: [fileObj] })) {
              return navigator.share({ files: [fileObj], title: 'Sans Armure', text: lead.trim() + ' ' + out.textContent + '.' })
                .then(function () { if (status) status.textContent = 'Sent.'; if (window.saBurst) window.saBurst(sec.querySelector('[data-dedicate-card]')); })
                .catch(function () { if (status) status.textContent = ''; });
            }
            var url = URL.createObjectURL(blob);
            var a = document.createElement('a'); a.href = url; a.download = fname;
            document.body.appendChild(a); a.click(); a.remove();
            setTimeout(function () { URL.revokeObjectURL(url); }, 4000);
            if (status) status.textContent = 'Saved. Send it to them.';
            if (window.saBurst) window.saBurst(sec.querySelector('[data-dedicate-card]'));
          });
      });
    });
  }

  /* Blueprint: drag between the drawing and the made jacket */
  function initBlueprint(root) {
    (root || document).querySelectorAll('[data-bp]').forEach(function (bp) {
      if (bp.dataset.ready) return; bp.dataset.ready = '1';
      var sec = bp.closest('.sa-bp') || bp;
      var stage = bp.querySelector('[data-bp-stage]');
      var handle = bp.querySelector('[data-bp-handle]');
      var coords = bp.querySelector('[data-bp-coords]');
      var arts = bp.querySelectorAll('[data-bp-face]');
      var keys = bp.querySelectorAll('[data-bp-key]');
      var views = bp.querySelectorAll('[data-bp-view]');
      if (!stage) return;
      var split = 100, dragging = false, touched = false, anim;

      function set(v) {
        split = Math.max(0, Math.min(100, v));
        stage.style.setProperty('--split', split + '%');
        if (handle) {
          handle.setAttribute('aria-valuenow', Math.round(split));
          handle.setAttribute('aria-valuetext', split > 66 ? 'Mostly drawing' : split < 34 ? 'Mostly photo' : 'Half drawing, half photo');
        }
      }
      function tween(to, ms) {
        cancelAnimationFrame(anim);
        if (reduce) { set(to); return; }
        var from = split, t0 = performance.now();
        (function step(now) {
          var p = Math.min(1, (now - t0) / ms), e = p < .5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
          set(from + (to - from) * e);
          if (p < 1) anim = requestAnimationFrame(step);
        })(t0);
      }
      function view(v) {
        stage.dataset.current = v;
        arts.forEach(function (a) { a.hidden = a.dataset.bpFace !== v; });
        keys.forEach(function (k) { k.hidden = k.dataset.bpKey !== v; });
        views.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.bpView === v ? 'true' : 'false'); });
        if (!reduce && sec.classList.contains('is-drawn')) { sec.classList.remove('is-drawn'); void sec.offsetWidth; sec.classList.add('is-drawn'); }
      }
      views.forEach(function (b) { b.addEventListener('click', function () { view(b.dataset.bpView); }); });
      view('front');
      set(100);

      function fromEvent(e) { var r = stage.getBoundingClientRect(); return (e.clientX - r.left) / r.width * 100; }
      stage.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        dragging = true; touched = true; cancelAnimationFrame(anim);
        stage.classList.add('is-dragging');
        set(fromEvent(e));
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      });
      stage.addEventListener('pointermove', function (e) {
        var r = stage.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        stage.style.setProperty('--cx', (x * 100).toFixed(2) + '%');
        stage.style.setProperty('--cy', (y * 100).toFixed(2) + '%');
        if (coords) coords.textContent = 'X ' + ('00' + (x * 100).toFixed(1)).slice(-5) + '   Y ' + ('00' + (y * 100).toFixed(1)).slice(-5);
        if (dragging) set(x * 100);
      });
      stage.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') stage.classList.add('is-hover'); });
      stage.addEventListener('pointerleave', function () { stage.classList.remove('is-hover'); });
      function end() { dragging = false; stage.classList.remove('is-dragging'); }
      stage.addEventListener('pointerup', end); stage.addEventListener('pointercancel', end);
      if (handle) handle.addEventListener('keydown', function (e) {
        var step = e.shiftKey ? 20 : 5;
        if (e.key === 'ArrowLeft') { set(split - step); e.preventDefault(); }
        else if (e.key === 'ArrowRight') { set(split + step); e.preventDefault(); }
        else if (e.key === 'Home') { set(0); e.preventDefault(); }
        else if (e.key === 'End') { set(100); e.preventDefault(); }
        touched = true;
      });

      function reveal() {
        sec.classList.add('is-drawn');
        if (!touched) setTimeout(function () { if (!touched) tween(52, 1600); }, reduce ? 0 : 2300);
      }
      if (reduce || !('IntersectionObserver' in window)) { sec.classList.add('is-drawn'); set(52); return; }
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { reveal(); io.disconnect(); } }, { threshold: .35 });
      io.observe(stage);
    });
  }

  /* Edition field: wake in a wave, swell near the pointer, ripple on choose */
  function initEditionFx(root) {
    (root || document).querySelectorAll('[data-edition]').forEach(function (sec) {
      if (sec.dataset.fx) return; sec.dataset.fx = '1';
      var facade = sec.querySelector('[data-facade]'); if (!facade) return;
      var wins = Array.prototype.slice.call(facade.querySelectorAll('.sa-win'));
      var cols = parseInt(getComputedStyle(facade).getPropertyValue('--cols'), 10) || 13;
      var rows = Math.ceil(wins.length / cols), cx = (cols - 1) / 2, cy = (rows - 1) / 2;
      wins.forEach(function (w, i) {
        var dx = i % cols - cx, dy = Math.floor(i / cols) - cy;
        w.style.setProperty('--d', (Math.sqrt(dx * dx + dy * dy) * 0.07).toFixed(2) + 's');
      });
      if (reduce || !('IntersectionObserver' in window)) sec.classList.add('is-awake');
      else { var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { sec.classList.add('is-awake'); io.disconnect(); } }, { threshold: 0.25 }); io.observe(facade); }
      if (reduce) return;
      if (finePointer) {
        var raf = 0, px = 0, py = 0;
        facade.addEventListener('pointermove', function (e) {
          px = e.clientX; py = e.clientY;
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = 0;
            var R = facade.getBoundingClientRect().width * 0.3;
            wins.forEach(function (w) {
              var b = w.getBoundingClientRect();
              var d = Math.hypot(b.left + b.width / 2 - px, b.top + b.height / 2 - py);
              w.style.setProperty('--p', Math.max(0, 1 - d / R).toFixed(2));
            });
          });
        });
        facade.addEventListener('pointerleave', function () { wins.forEach(function (w) { w.style.removeProperty('--p'); }); });
      }
      facade.addEventListener('click', function (e) {
        var t = e.target.closest('.sa-win'); if (!t || t.classList.contains('is-taken')) return;
        var n = wins.indexOf(t), tx = n % cols, ty = Math.floor(n / cols);
        wins.forEach(function (w, i) {
          if (w === t) return;
          var d = Math.hypot(i % cols - tx, Math.floor(i / cols) - ty);
          w.classList.remove('is-ripple'); void w.offsetWidth;
          w.style.setProperty('--rd', (d * 0.045).toFixed(2) + 's');
          w.classList.add('is-ripple');
        });
      });
    });
  }

  /* Edition facade: 117 windows, choose your number */
  function initEdition(root) {
    (root || document).querySelectorAll('[data-edition]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var total = parseInt(sec.dataset.total, 10) || 117;
      var facade = sec.querySelector('[data-facade]');
      var wins = Array.prototype.slice.call(sec.querySelectorAll('.sa-win'));
      var digitsEl = sec.querySelector('[data-digits]');
      var meaning = sec.querySelector('[data-edition-meaning]');
      var input = sec.querySelector('[data-edition-input]');
      var tags = sec.querySelector('[data-edition-tags]');
      var submit = sec.querySelector('[data-edition-submit]');
      var cols = parseInt(getComputedStyle(facade).getPropertyValue('--cols'), 10) || 13;
      var floors = Math.ceil(total / cols);
      var current = 0;

      /* digit rollers */
      var rollers = [];
      if (digitsEl) {
        digitsEl.textContent = '';
        for (var d = 0; d < 3; d++) {
          var wrap = document.createElement('span'); wrap.className = 'sa-digit';
          var col = document.createElement('span');
          var html = '<i>0</i>'; for (var k = 0; k <= 9; k++) html += '<i>' + k + '</i>';
          col.innerHTML = html; wrap.appendChild(col); digitsEl.appendChild(wrap); rollers.push(col);
        }
      }
      function roll(n) {
        var str = ('00' + n).slice(-3);
        rollers.forEach(function (col, i) {
          var v = n ? parseInt(str[i], 10) + 1 : 0;
          col.style.transitionDelay = (i * 0.08) + 's';
          col.style.transform = 'translateY(' + (-v) + 'em)';
        });
        if (digitsEl) digitsEl.setAttribute('aria-label', n ? 'Number ' + n : 'No number chosen');
      }
      function describe(n) {
        var floor = floors - Math.floor((n - 1) / cols);
        var win = ((n - 1) % cols) + 1;
        var extra = n === 1 ? ' · The first one' : n === total ? ' · The last one' : n === 17 ? ' · The 17 on the jacket' : '';
        return 'Floor ' + floor + ' · Window ' + win + extra;
      }
      function choose(n, focus) {
        n = Math.max(1, Math.min(total, n | 0));
        current = n;
        wins.forEach(function (w) {
          var on = +w.dataset.n === n;
          w.setAttribute('aria-pressed', on ? 'true' : 'false');
          w.tabIndex = on ? 0 : -1;
        });
        var w = wins[n - 1];
        if (focus && w) w.focus();
        roll(n);
        if (meaning) meaning.textContent = describe(n);
        if (input && +input.value !== n) input.value = n;
        if (tags) tags.value = 'prelaunch, edition-request, no-' + ('00' + n).slice(-3);
        if (submit) submit.disabled = false;
        if (window.saSound) window.saSound('turn');
      }
      var sold = parseInt(sec.dataset.sold, 10) || 0;
      wins.forEach(function (w) {
        w.addEventListener('click', function () {
          if (w.classList.contains('is-taken')) { if (meaning) meaning.textContent = 'No. ' + ('00' + w.dataset.n).slice(-3) + ' is already out in the world.'; return; }
          choose(+w.dataset.n);
        });
      });
      facade.addEventListener('keydown', function (e) {
        var n = current || 1, map = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: cols, ArrowUp: -cols };
        if (map[e.key] === undefined) return;
        e.preventDefault();
        var nx = Math.max(sold + 1, Math.min(total, n + map[e.key]));
        choose(nx, true);
      });
      if (input) input.addEventListener('input', function () {
        var v = parseInt(input.value, 10);
        if (v >= 1 && v <= total) { if (v <= sold) { if (meaning) meaning.textContent = 'No. ' + ('00' + v).slice(-3) + ' is already out in the world.'; } else choose(v); }
      });
      roll(0);

      /* windows light up at dusk */
      if (reduce || !('IntersectionObserver' in window)) {
        wins.forEach(function (w, i) { if ((i * 37) % 5 < 2) w.classList.add('is-lit'); });
        return;
      }
      var lit = false;
      var io = new IntersectionObserver(function (en) {
        if (!en[0].isIntersecting || lit) return; lit = true; io.disconnect();
        var order = wins.filter(function (w) { return !w.classList.contains('is-taken'); }).sort(function () { return Math.random() - .5; }).slice(0, Math.round(total * .42));
        order.forEach(function (w, i) {
          setTimeout(function () { w.classList.add('is-lit'); if (Math.random() < .35) w.classList.add('is-dim'); }, 300 + i * 38 + Math.random() * 120);
        });
        setInterval(function () {
          if (document.hidden) return;
          var w = wins[(Math.random() * wins.length) | 0];
          if (w.getAttribute('aria-pressed') === 'true' || w.classList.contains('is-taken')) return;
          w.classList.toggle('is-lit');
        }, 900);
      }, { threshold: .3 });
      io.observe(facade);
    });
  }

  /* Sheet title block, scale ruler and layout grid */
  var sheetDone = false;
  function initSheet() {
    if (sheetDone) return; sheetDone = true;
    var sheet = document.querySelector('[data-sheet]');
    var ruler = document.querySelector('[data-ruler]');
    var mark = document.querySelector('[data-ruler-mark]');
    var gridBtn = document.querySelectorAll('[data-grid-toggle]');
    function setGrid(on) {
      document.documentElement.classList.toggle('sa-grid-on', on);
      gridBtn.forEach(function (b) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); b.textContent = on ? 'Hide the grid' : 'Show the grid'; });
    }
    gridBtn.forEach(function (b) { b.addEventListener('click', function () { setGrid(!document.documentElement.classList.contains('sa-grid-on')); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'g' && e.key !== 'G') return;
      if (e.metaKey || e.ctrlKey || e.altKey) return;
      var t = e.target; if (t && (t.isContentEditable || /^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName))) return;
      setGrid(!document.documentElement.classList.contains('sa-grid-on'));
    });
    if (!sheet) return;
    var secs = Array.prototype.slice.call(document.querySelectorAll('main .shopify-section, main > section')).filter(function (s) { return s.offsetHeight > 0; });
    var noEl = sheet.querySelector('[data-sheet-no]'), nameEl = sheet.querySelector('[data-sheet-name]'), countEl = sheet.querySelector('[data-sheet-count]');
    var names = secs.map(function (s, i) {
      var inner = s.matches('[data-sheet-title]') ? s : s.querySelector('[data-sheet-title]');
      var t = inner && inner.getAttribute('data-sheet-title');
      if (!t) { var eb = s.querySelector('.sa-eyebrow'); t = eb ? eb.textContent : ''; }
      if (!t) { var h = s.querySelector('h1, h2'); t = h ? h.textContent : ''; }
      t = (t || 'Sheet').replace(/\s+/g, ' ').trim();
      if (i === 0) t = 'Cover';
      return t.length > 22 ? t.slice(0, 21) + '…' : t;
    });
    secs.forEach(function (s, i) {
      var inner = s.querySelector('[data-bp-sheet]');
      if (inner) inner.textContent = 'A-' + (101 + i) + ' of ' + secs.length;
    });
    var cur = -1;
    function show(i) {
      if (i === cur || i < 0) return; cur = i;
      noEl.textContent = 'A-' + (101 + i);
      nameEl.textContent = names[i];
      if (countEl) countEl.textContent = 'Sheet ' + (i + 1) + ' of ' + secs.length + ' · Drop 001';
      if (!reduce) { sheet.classList.remove('is-flip'); void sheet.offsetWidth; sheet.classList.add('is-flip'); }
    }
    var tick = false;
    function update() {
      tick = false;
      var mid = innerHeight * .45, idx = 0;
      for (var i = 0; i < secs.length; i++) { if (secs[i].getBoundingClientRect().top <= mid) idx = i; }
      show(idx);
      var max = document.documentElement.scrollHeight - innerHeight;
      var p = max > 0 ? scrollY / max : 0;
      if (mark) mark.style.setProperty('--p', p.toFixed(4));
      var on = scrollY > innerHeight * .5;
      sheet.classList.toggle('is-on', on);
      if (ruler) ruler.classList.toggle('is-on', on);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* The house: chapters as floors, follow one */
  function initHouse(root) {
    (root || document).querySelectorAll('[data-house]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var floors = sec.querySelectorAll('.sa-floor');
      var panel = sec.querySelector('[data-house-panel]');
      if (!panel || !floors.length) return;
      var lvl = panel.querySelector('[data-house-level]'), nm = panel.querySelector('[data-house-name]');
      var meta = panel.querySelector('[data-house-meta]'), desc = panel.querySelector('[data-house-desc]');
      var tags = panel.querySelector('[data-house-tags]'), label = panel.querySelector('[data-house-follow-label]');
      var baseLabel = label ? label.textContent : '';
      function pick(f, animate) {
        floors.forEach(function (x) { x.setAttribute('aria-pressed', x === f ? 'true' : 'false'); });
        var n = ('0' + f.dataset.floor).slice(-2);
        if (lvl) lvl.textContent = 'Floor ' + n;
        if (nm) nm.textContent = f.dataset.name;
        if (meta) meta.textContent = [f.dataset.category, f.dataset.statusLabel, f.dataset.year].filter(Boolean).join(' · ');
        var tpl = f.parentNode.querySelector('template[data-floor-desc]');
        if (desc && tpl) desc.innerHTML = tpl.innerHTML;
        if (tags) tags.value = 'prelaunch, ' + f.dataset.tag;
        if (label) label.textContent = f.dataset.status === 'open' ? baseLabel : (f.dataset.status === 'building' ? 'Tell me when this floor opens' : 'Tell me when this floor is built');
        if (animate && !reduce) { panel.classList.remove('is-swap'); void panel.offsetWidth; panel.classList.add('is-swap'); }
      }
      floors.forEach(function (f) { f.addEventListener('click', function () { pick(f, true); if (window.saSound) window.saSound('turn'); }); });
      var first = sec.querySelector('.sa-floor[data-floor="1"]') || floors[floors.length - 1];
      pick(first, false);
    });
  }

  /* Proof you were here: visits kept on this device, letters open as people return */
  var proofDone = false;
  function initProof() {
    if (proofDone) return; proofDone = true;
    var box = document.querySelector('[data-proof]');
    if (!box) return;
    var KEY = 'sa-proof-v1';
    var gap = (parseFloat(box.dataset.gapHours) || 6) * 3600000;
    var store = null;
    try { var raw = localStorage.getItem(KEY); store = raw ? JSON.parse(raw) : null; } catch (e) { store = null; }
    var memoryOnly = false;
    try { localStorage.setItem('sa-proof-test', '1'); localStorage.removeItem('sa-proof-test'); } catch (e) { memoryOnly = true; }
    if (!store || !Array.isArray(store.v)) store = { v: [], seen: 0 };
    var now = Date.now(), last = store.v[store.v.length - 1] || 0;
    var isNewVisit = !last || now - last > gap;
    if (isNewVisit) { store.v.push(now); if (store.v.length > 400) store.v = store.v.slice(-400); }
    var count = store.v.length;
    function save() { try { localStorage.setItem(KEY, JSON.stringify(store)); } catch (e) {} }
    save();

    var tab = box.querySelector('[data-proof-open]'), dlg = box.querySelector('[data-proof-dialog]');
    var toast = box.querySelector('[data-proof-toast]');
    var letters = Array.prototype.slice.call(box.querySelectorAll('[data-letter]'));
    var fmt = function (t) { try { return new Date(t).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' }); } catch (e) { return ''; } };

    var openCount = 0, freshCount = 0;
    letters.forEach(function (l) {
      var need = parseInt(l.dataset.visits, 10) || 1;
      if (count >= need) {
        openCount++;
        l.classList.add('is-open');
        l.querySelector('.sa-letter__open').hidden = false;
        if (need > (store.seen || 0)) { l.classList.add('is-fresh'); freshCount++; }
      } else {
        var w = l.querySelector('.sa-letter__when');
        if (w) w.textContent = 'Opens on visit ' + need + ' · ' + (need - count) + ' to go';
      }
    });

    if (tab) {
      tab.hidden = false;
      tab.querySelector('[data-proof-count]').textContent = count;
      tab.setAttribute('aria-label', 'Proof you were here: ' + count + (count === 1 ? ' visit' : ' visits') + (freshCount ? ', new letter' : ''));
      if (freshCount && count > 1) tab.classList.add('has-new');
    }
    if (freshCount && count > 1 && toast) {
      setTimeout(function () {
        toast.textContent = freshCount > 1 ? freshCount + ' letters opened for you' : 'A letter opened for you';
        toast.classList.add('is-on');
        setTimeout(function () { toast.classList.remove('is-on'); }, 5200);
      }, 3200);
    }

    function draw() {
      var first = box.querySelector('[data-proof-first]'), vis = box.querySelector('[data-proof-visits]'), lst = box.querySelector('[data-proof-last]');
      if (first) first.textContent = fmt(store.v[0]);
      if (vis) vis.textContent = count + (memoryOnly ? ' (this visit only)' : '');
      if (lst) lst.textContent = count > 1 ? fmt(store.v[count - 2]) : 'Now';
      var svg = box.querySelector('[data-proof-ecg]'); if (!svg) return;
      var pts = store.v.slice(-24), n = pts.length, d = 'M0 35';
      pts.forEach(function (t, i) {
        var x = n === 1 ? 300 : 30 + i * (540 / (n - 1));
        var h = 16 + (i === n - 1 ? 14 : (i % 3) * 3);
        d += ' L' + (x - 12) + ' 35 L' + (x - 6) + ' ' + (35 - h * .35) + ' L' + x + ' ' + (35 + h * .5) + ' L' + (x + 5) + ' ' + (35 - h) + ' L' + (x + 10) + ' ' + (35 + h * .35) + ' L' + (x + 15) + ' 35';
      });
      d += ' L600 35';
      var path = svg.querySelector('path'); path.setAttribute('d', d);
      if (!reduce && path.getTotalLength) {
        var len = path.getTotalLength();
        path.style.strokeDasharray = len; path.style.strokeDashoffset = len;
        path.getBoundingClientRect();
        path.style.transition = 'stroke-dashoffset 1.8s cubic-bezier(.3,.6,.2,1)';
        path.style.strokeDashoffset = 0;
      }
    }
    function open() {
      draw();
      if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
      tab.classList.remove('has-new');
      var maxOpen = 0; letters.forEach(function (l) { var need = +l.dataset.visits; if (count >= need) maxOpen = Math.max(maxOpen, need); });
      store.seen = Math.max(store.seen || 0, maxOpen); save();
      if (window.saSound) window.saSound('beat');
    }
    function close() { if (dlg.close) dlg.close(); else dlg.removeAttribute('open'); letters.forEach(function (l) { l.classList.remove('is-fresh'); }); }
    if (tab && dlg) {
      tab.addEventListener('click', open);
      box.querySelector('[data-proof-close]').addEventListener('click', close);
      dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
      dlg.addEventListener('close', function () { letters.forEach(function (l) { l.classList.remove('is-fresh'); }); });
    }
    var clear = box.querySelector('[data-proof-clear]');
    if (clear) clear.addEventListener('click', function () {
      try { localStorage.removeItem(KEY); } catch (e) {}
      clear.textContent = 'Forgotten';
      setTimeout(function () { location.reload(); }, 700);
    });
  }

  /* Tees: the light switch between white and black, paint on click, add to bag */
  function initTees(root) {
    (root || document).querySelectorAll('[data-tees]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var sw = sec.querySelector('[data-tees-switch]'), wash = sec.querySelector('[data-tees-wash]');
      var nameEl = sec.querySelector('[data-tees-name]');
      var tees = sec.querySelectorAll('[data-tee]');
      var busy = false;
      function apply(mode) {
        sec.dataset.mode = mode;
        tees.forEach(function (t) {
          var on = t.dataset.tee === mode; t.hidden = !on;
          if (on && !reduce) { t.classList.remove('is-entering'); void t.offsetWidth; t.classList.add('is-entering'); }
        });
        if (nameEl) nameEl.textContent = mode === 'black' ? 'Black' : 'White';
        if (sw) { sw.setAttribute('aria-pressed', mode === 'black' ? 'true' : 'false'); sw.setAttribute('aria-label', mode === 'black' ? 'Show the white tee' : 'Show the black tee'); }
      }
      if (sw) sw.addEventListener('click', function () {
        if (busy) return;
        var next = sec.dataset.mode === 'black' ? 'white' : 'black';
        if (window.saSound) window.saSound('turn');
        if (reduce || !wash) { apply(next); return; }
        busy = true;
        var r = sec.getBoundingClientRect(), b = sw.getBoundingClientRect();
        wash.style.setProperty('--wx', (b.left + b.width / 2 - r.left) + 'px');
        wash.style.setProperty('--wy', (b.top + b.height / 2 - r.top) + 'px');
        wash.style.background = next === 'black' ? '#173F7C' : '#F8FBFF';
        wash.classList.remove('is-going'); void wash.offsetWidth; wash.classList.add('is-going');
        setTimeout(function () { apply(next); }, 420);
        setTimeout(function () { wash.classList.remove('is-going'); wash.style.background = ''; busy = false; }, 1150);
      });

      sec.querySelectorAll('[data-tee-flip]').forEach(function (print) {
        var btn = print.querySelector('[data-tee-turn]');
        function flip() {
          var back = !print.classList.contains('is-back');
          print.classList.toggle('is-back', back);
          if (btn) { btn.textContent = back ? 'See the front' : 'See the back'; btn.setAttribute('aria-pressed', back ? 'true' : 'false'); }
        }
        if (btn) btn.addEventListener('click', function (e) { e.stopPropagation(); flip(); });
        print.addEventListener('click', flip);
        if (finePointer && !reduce) {
          print.addEventListener('pointermove', function (e) {
            var r = print.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - .5, y = (e.clientY - r.top) / r.height - .5;
            print.classList.add('is-tilting');
            print.style.setProperty('--ty', (x * 22).toFixed(1) + 'deg'); print.style.setProperty('--tx', (-y * 18).toFixed(1) + 'deg');
          });
          print.addEventListener('pointerleave', function () { print.classList.remove('is-tilting'); print.style.setProperty('--ty', '0deg'); print.style.setProperty('--tx', '0deg'); });
        }
      });

      /* hand-applied splatter: click anywhere in the section */
      if (!reduce) sec.addEventListener('pointerdown', function (e) {
        if (e.target.closest('button, a, input, label, [data-tee-flip], form')) return;
        var r = sec.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top;
        var n = 6 + (Math.random() * 7 | 0);
        for (var i = 0; i < n; i++) {
          var d = document.createElement('span'); d.className = 'sa-splat';
          var s = i === 0 ? 10 + Math.random() * 12 : 2 + Math.random() * 7;
          var a = Math.random() * Math.PI * 2, dist = i === 0 ? 0 : 8 + Math.random() * 46;
          d.style.width = d.style.height = s + 'px';
          d.style.left = (x + Math.cos(a) * dist) + 'px'; d.style.top = (y + Math.sin(a) * dist) + 'px';
          d.style.animationDelay = (i * 0.012) + 's';
          sec.appendChild(d);
          setTimeout(function (el) { el.remove(); }.bind(null, d), 2800);
        }
      });

      sec.querySelectorAll('[data-tee-form]').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          var st = form.querySelector('[data-tee-status]'), btn = form.querySelector('[data-tee-add]');
          var fd = new FormData(form);
          if (!fd.get('id')) { if (st) st.textContent = 'Choose a size first.'; return; }
          if (btn) btn.disabled = true;
          if (st) st.textContent = 'Adding…';
          var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
            .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.j && (res.j.description || res.j.message) || 'Could not add');
              if (st) st.innerHTML = 'Added to your bag. <a href="' + root + 'cart">View bag →</a>';
              if (window.saCart) window.saCart.added();
              if (window.saBurst) window.saBurst(btn);
            })
            .catch(function (err) { if (st) st.textContent = err.message || 'Something went wrong. Try again.'; })
            .then(function () { if (btn) btn.disabled = false; });
        });
      });
    });
  }

  /* Bag: header count and a slide-out bag that talks to Shopify's cart */
  var bagDone = false;
  function initBag() {
    if (bagDone) return; bagDone = true;
    var bag = document.querySelector('[data-bag]');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var openers = document.querySelectorAll('[data-bag-open]');
    var lastFocus = null, cart = null;
    function money(c, cur) { try { return (c / 100).toLocaleString(undefined, { style: 'currency', currency: cur || 'USD' }); } catch (e) { return '$' + (c / 100).toFixed(2); } }
    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
    function setCount(n, bump) {
      document.querySelectorAll('[data-bag-count]').forEach(function (el) { el.textContent = n; });
      openers.forEach(function (o) {
        o.classList.toggle('has-items', n > 0);
        o.setAttribute('aria-label', 'Bag, ' + n + (n === 1 ? ' item' : ' items'));
        if (bump && !reduce) { o.classList.remove('is-bump'); void o.offsetWidth; o.classList.add('is-bump'); setTimeout(function () { o.classList.remove('is-bump'); }, 450); }
      });
    }
    function render() {
      if (!bag || !cart) return;
      var list = bag.querySelector('[data-bag-items]'), empty = bag.querySelector('[data-bag-empty]'), foot = bag.querySelector('[data-bag-foot]');
      var has = cart.item_count > 0;
      empty.hidden = has; foot.hidden = !has; list.hidden = !has;
      list.innerHTML = cart.items.map(function (it) {
        var img = it.image ? (it.image.indexOf('data:') === 0 ? it.image : it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200') : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        return '<div class="sa-bag__item" data-key="' + esc(it.key) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '<span></span>') +
          '<div><p class="sa-bag__name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>' +
          (variant ? '<p class="sa-bag__variant">' + esc(variant) + '</p>' : '') +
          (it.properties && it.properties['Pre-order'] ? '<p class="sa-bag__pre sa-mono">' + esc(it.properties['Pre-order']) + '</p>' : '') +
          '<div class="sa-bag__qty"><button type="button" data-qty="-1" aria-label="One less">−</button><span>' + it.quantity + '</span><button type="button" data-qty="1" aria-label="One more">+</button></div></div>' +
          '<div><p class="sa-bag__line">' + money(it.final_line_price, cart.currency) + '</p><button type="button" class="sa-bag__remove" data-remove>Remove</button></div></div>';
      }).join('');
      bag.querySelector('[data-bag-subtotal]').textContent = money(cart.total_price, cart.currency);
      setCount(cart.item_count);
    }
    function refresh() {
      return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cart = c; render(); return c; })
        .catch(function () {});
    }
    function change(key, qty, row) {
      if (row) row.classList.add('is-busy');
      return fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); })
        .then(function (c) { if (c && c.items) { cart = c; render(); } else { refresh(); } })
        .catch(function () { refresh(); });
    }
    function open() {
      if (!bag) { location.href = root + 'cart'; return; }
      lastFocus = document.activeElement;
      bag.hidden = false;
      requestAnimationFrame(function () { bag.classList.add('is-open'); });
      var panel = bag.querySelector('.sa-bag__panel'); if (panel) panel.focus();
      document.documentElement.style.overflow = 'hidden';
      refresh();
    }
    function close() {
      if (!bag) return;
      bag.classList.remove('is-open');
      document.documentElement.style.overflow = '';
      setTimeout(function () { bag.hidden = true; }, reduce ? 0 : 450);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    openers.forEach(function (o) { o.addEventListener('click', function (e) { if (!bag) return; e.preventDefault(); open(); }); });
    if (bag) {
      bag.querySelectorAll('[data-bag-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !bag.hidden) close(); });
      bag.querySelector('[data-bag-items]').addEventListener('click', function (e) {
        var row = e.target.closest('.sa-bag__item'); if (!row || !cart) return;
        var key = row.dataset.key, it = cart.items.filter(function (x) { return x.key === key; })[0]; if (!it) return;
        if (e.target.closest('[data-remove]')) change(key, 0, row);
        var q = e.target.closest('[data-qty]'); if (q) change(key, Math.max(0, it.quantity + parseInt(q.dataset.qty, 10)), row);
      });
    }
    window.saCart = { open: open, refresh: refresh, added: function () { refresh().then(function (c) { if (c) setCount(c.item_count, true); open(); }); } };
    var n = parseInt((openers[0] && openers[0].querySelector('[data-bag-count]') || {}).textContent, 10);
    if (!isNaN(n)) setCount(n);
  }

  /* Quick buy on the home page, and a buy bar that follows the page */
  function ajaxAdd(fd) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add'); return j; }); });
  }
  function initQuickbuy(root) {
    (root || document).querySelectorAll('[data-quickbuy]').forEach(function (form) {
      if (form.dataset.ready) return; form.dataset.ready = '1';
      var st = form.querySelector('[data-quickbuy-status]'), btn = form.querySelector('[data-quickbuy-add]');
      form.addEventListener('change', function (e) {
        if (e.target.name !== 'id') return;
        var sel = document.querySelector('[data-buybar-size]'); if (sel) sel.value = e.target.value;
        var bb = document.querySelector('[data-buybar-add]'); if (bb) bb.dataset.variant = e.target.value;
      });
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        e.preventDefault();
        var fd = new FormData(form);
        if (!fd.get('id')) { if (st) st.textContent = 'Choose a size first.'; return; }
        btn.disabled = true; if (st) st.textContent = 'Adding…';
        ajaxAdd(fd).then(function () {
          if (st) st.textContent = 'Added to your bag.';
          if (window.saBurst) window.saBurst(btn);
          if (window.saCart) window.saCart.added();
        }).catch(function (err) { if (st) st.textContent = err.message; })
          .then(function () { btn.disabled = false; });
      });
    });
  }
  var buybarDone = false;
  function initBuybar() {
    if (buybarDone) return;
    var bar = document.querySelector('[data-buybar]'); if (!bar) return;
    buybarDone = true;
    var buy = document.querySelector('[data-drop-buy]') || bar.closest('section');
    var stop = document.getElementById('join') || document.querySelector('.sa-footer');
    var on = false, tick = false;
    function set(v) {
      if (v === on) return; on = v;
      bar.classList.toggle('is-on', v); bar.setAttribute('aria-hidden', v ? 'false' : 'true');
      bar.querySelectorAll('a, button, select').forEach(function (el) { el.tabIndex = v ? 0 : -1; });
      document.body.classList.toggle('has-buybar', v);
    }
    function update() {
      tick = false;
      var past = buy.getBoundingClientRect().bottom < 0;
      var atEnd = stop && stop.getBoundingClientRect().top < innerHeight * .85;
      var bagOpen = document.querySelector('[data-bag].is-open');
      set(past && !atEnd && !bagOpen);
    }
    window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    var sel = bar.querySelector('[data-buybar-size]'), add = bar.querySelector('[data-buybar-add]');
    if (sel && add) sel.addEventListener('change', function () {
      add.dataset.variant = sel.value;
      var r = document.querySelector('[data-quickbuy] input[name="id"][value="' + sel.value + '"]'); if (r) r.checked = true;
    });
    if (add) add.addEventListener('click', function () {
      var fd = new FormData(); fd.append('id', add.dataset.variant); fd.append('quantity', '1');
      if (add.dataset.preorder) fd.append('properties[Pre-order]', add.dataset.preorder);
      bar.classList.add('is-busy');
      ajaxAdd(fd).then(function () { if (window.saBurst) window.saBurst(add); if (window.saCart) window.saCart.added(); })
        .catch(function (err) { var p = bar.querySelector('[data-buybar-price]'); if (p) p.textContent = err.message; })
        .then(function () { bar.classList.remove('is-busy'); });
    });
  }

  /* Size helper inside the size chart */
  function initFinder(root) {
    (root || document).querySelectorAll('[data-finder]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var rows = [], advice = '';
      try { rows = JSON.parse(box.querySelector('[data-finder-rows]').textContent); } catch (e) {}
      try { advice = JSON.parse(box.querySelector('[data-finder-advice]').textContent) || ''; } catch (e) {}
      var usual = box.querySelector('[data-finder-usual]'), chest = box.querySelector('[data-finder-chest]'), out = box.querySelector('[data-finder-result]');
      function range(t) { var m = String(t || '').match(/[\d.]+/g); if (!m) return null; var a = parseFloat(m[0]), b = parseFloat(m[m.length - 1]); return [a, b]; }
      function run() {
        var c = parseFloat(chest.value), pick = null, why = '';
        var hasBody = rows.some(function (r) { return r.body; });
        if (!isNaN(c) && c > 0) {
          if (hasBody) {
            var best = null, bestD = 1e9;
            rows.forEach(function (r) { var g = range(r.body); if (!g) return; var d = c < g[0] ? g[0] - c : c > g[1] ? c - g[1] : 0; if (d < bestD) { bestD = d; best = r; } });
            if (best) { pick = best.size; why = bestD === 0 ? 'Your chest sits right in its range.' : 'It\'s the closest match to your chest.'; }
          } else {
            var ease = 6, best2 = null;
            rows.forEach(function (r) { var g = range(r.chest); if (g && !best2 && g[0] >= c + ease) best2 = r; });
            if (!best2 && rows.length) best2 = rows[rows.length - 1];
            if (best2) { pick = best2.size; why = 'That leaves the room this oversized cut is meant to have.'; }
          }
        } else if (usual.value) {
          pick = usual.value; why = 'It runs true to your usual size.';
        }
        if (!pick) { out.textContent = ''; return; }
        out.innerHTML = 'We\'d suggest <strong>' + pick.replace(/</g, '') + '</strong>. ' + why + (advice ? ' ' + advice.replace(/</g, '') : '');
      }
      usual.addEventListener('change', run); chest.addEventListener('input', run);
    });
    if (location.hash === '#sizes') {
      var dlg = document.querySelector('[data-sizes]');
      if (dlg && dlg.showModal) setTimeout(function () { try { dlg.showModal(); } catch (e) {} }, 400);
    }
  }

  /* Soft light that follows the cursor across dark sections */
  var lightDone = false;
  function initLight() {
    if (lightDone || reduce || !finePointer) return; lightDone = true;
    document.documentElement.classList.add('has-light');
    var cur = null, tick = false, ev = null;
    document.addEventListener('pointermove', function (e) {
      ev = e; if (tick) return; tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var sec = ev.target && ev.target.closest ? ev.target.closest('.sa-section.scheme-dark') : null;
        if (cur && cur !== sec) { cur.style.setProperty('--ly', '-20%'); }
        cur = sec; if (!sec) return;
        var r = sec.getBoundingClientRect();
        sec.style.setProperty('--lx', (ev.clientX - r.left) + 'px');
        sec.style.setProperty('--ly', (ev.clientY - r.top) + 'px');
      });
    }, { passive: true });
  }


  /* Hero: a balloon you hold by its string. Click to let it go. */
  function initTether(root) {
    (root || document).querySelectorAll('[data-tether]').forEach(function (hero) {
      if (hero.dataset.tetherReady) return; hero.dataset.tetherReady = '1';
      var bal = hero.querySelector('.sa-tether__balloon');
      var svg = hero.querySelector('.sa-tether__string');
      var path = svg && svg.querySelector('path');
      var hint = hero.querySelector('.sa-tether__hint');
      var tag = hero.querySelector('[data-tether-tag]'), tagN = 0;
      var count = hero.querySelector('[data-tether-count]');
      if (!bal || !path) return;
      if (reduce) { hero.classList.add('is-still'); return; }
      var W = 0, H = 0, len = 180, bh = 120;
      var hand = { x: 0, y: 0 }, pos = { x: 0, y: 0 }, vel = { x: 0, y: 0 }, tail = { x: 0, y: 0 };
      var following = false, released = false, started = false, visible = true, raf = 0, freed = 0;
      try { freed = parseInt(sessionStorage.getItem('sa-let-go') || '0', 10) || 0; } catch (e) {}
      function size() {
        var r = hero.getBoundingClientRect(); W = r.width; H = r.height;
        bh = bal.offsetHeight || 120; len = Math.max(110, Math.min(230, H * .25));
        svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
      }
      function rest(t) {
        var narrow = W < 750;
        return { x: W * (narrow ? .91 : .77) + Math.sin(t / 2300) * (narrow ? 5 : 12), y: H * (narrow ? .4 : .6) + Math.cos(t / 1900) * 9 };
      }
      function spawn(t) {
        var r = rest(t); hand.x = r.x; hand.y = r.y;
        pos.x = r.x; pos.y = H + bh; vel.x = 0; vel.y = 0; released = false;
        hero.classList.remove('is-released');
      }
      function show() { if (count && freed) { count.textContent = freed + (freed === 1 ? ' balloon let go' : ' balloons let go'); count.hidden = false; } }
      function frame(t) {
        raf = 0; if (!visible) return;
        if (!started) { started = true; size(); spawn(t); pos.y = H * .9; }
        if (!released) {
          if (!following) { var r = rest(t); hand.x += (r.x - hand.x) * .04; hand.y += (r.y - hand.y) * .04; }
          var tx = hand.x + Math.sin(t / 900) * 5, ty = hand.y - len - bh / 2;
          vel.x += (tx - pos.x) * .028; vel.y += (ty - pos.y) * .028;
          vel.x *= .86; vel.y *= .86;
          tail.x = hand.x; tail.y = hand.y;
        } else {
          vel.y -= .22; vel.x += Math.sin(t / 500) * .05; vel.x *= .98;
          tail.x += (pos.x - tail.x) * .08; tail.y += (pos.y + bh / 2 + len * .9 - tail.y) * .08;
          if (pos.y < -bh * 2 - len) spawn(t);
        }
        pos.x += vel.x; pos.y += vel.y;
        var kx = pos.x, ky = pos.y + bh / 2;
        var lean = Math.max(-28, Math.min(28, (pos.x - tail.x) * .22));
        bal.style.transform = 'translate3d(' + (pos.x).toFixed(1) + 'px,' + (pos.y).toFixed(1) + 'px,0) translate(-50%,-50%) rotate(' + lean.toFixed(2) + 'deg)';
        var a = lean * Math.PI / 180;
        kx = pos.x - Math.sin(a) * bh / 2; ky = pos.y + Math.cos(a) * bh / 2;
        var cx = kx - Math.sin(a) * len * .35 - vel.x * 3, cy = (ky + tail.y) / 2 + Math.abs(vel.x) * 1.5;
        path.setAttribute('d', 'M' + kx.toFixed(1) + ' ' + ky.toFixed(1) + ' Q' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ' ' + tail.x.toFixed(1) + ' ' + tail.y.toFixed(1));
        if (tag) {
          tag.style.transform = 'translate3d(' + (pos.x + bh * .5).toFixed(1) + 'px,' + (pos.y - 6).toFixed(1) + 'px,0)';
          if (++tagN % 5 === 0) {
            var alt = Math.max(0, Math.round((1 - pos.y / H) * 1170));
            tag.textContent = 'N\u00BA ' + ('00' + (freed + 1)).slice(-3) + ' \u00B7 ALT ' + ('000' + alt).slice(-4);
          }
        }
        raf = requestAnimationFrame(frame);
      }
      function go() { if (!raf && visible) raf = requestAnimationFrame(frame); }
      if (finePointer) {
        hero.addEventListener('pointermove', function (e) {
          if (released) return;
          var r = hero.getBoundingClientRect();
          following = true; hand.x = e.clientX - r.left; hand.y = e.clientY - r.top;
          if (hint) hint.classList.add('is-on');
        }, { passive: true });
        hero.addEventListener('pointerleave', function () { following = false; });
      }
      hero.addEventListener('click', function (e) {
        if (released || e.target.closest('a, button, input, label, form, .sa-balloon')) return;
        if (!finePointer && !e.target.closest('.sa-tether__balloon')) return;
        released = true; following = false; vel.y = -3; hero.classList.add('is-released');
        freed++; try { sessionStorage.setItem('sa-let-go', String(freed)); } catch (err) {}
        show(); if (hint) hint.classList.add('is-done');
        monitors.forEach(function (m) { m.saTrigger && m.saTrigger(); });
        if (window.saSound) window.saSound('chime');
      });
      show();
      window.addEventListener('resize', size, { passive: true });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; go(); }).observe(hero);
      }
      go();
    });
  }

  /* Hero clouds drift a little with the cursor and with scroll */
  function initClouds(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-clouds]').forEach(function (el) {
      if (el.dataset.ready) return; el.dataset.ready = '1';
      var hero = el.closest('section') || el, mx = 0, tick = false;
      function apply() {
        tick = false;
        var s = Math.min(1, Math.max(0, window.scrollY / (hero.offsetHeight || 1)));
        el.style.setProperty('--cx', mx.toFixed(3)); el.style.setProperty('--cs', s.toFixed(3));
      }
      function ask() { if (!tick) { tick = true; requestAnimationFrame(apply); } }
      if (finePointer) hero.addEventListener('pointermove', function (e) { mx = e.clientX / window.innerWidth - .5; ask(); }, { passive: true });
      window.addEventListener('scroll', ask, { passive: true });
    });
  }

  /* The picture: follow the string down from the balloon to the boy */
  function initWorld(root) {
    (root || document).querySelectorAll('[data-world]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      if (reduce) { sec.style.setProperty('--p', '1'); return; }
      var tick = false;
      function update() {
        tick = false;
        var r = sec.getBoundingClientRect(), vh = window.innerHeight;
        var p = (vh * .85 - r.top) / (r.height - vh * .25);
        p = Math.max(0, Math.min(1, p));
        sec.style.setProperty('--p', p.toFixed(4));
        sec.classList.toggle('is-landed', p > .82);
      }
      window.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(update); } }, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    });
  }

  /* Colors preview: every balloon is blue until you pick it */
  function initColors(root) {
    (root || document).querySelectorAll('[data-colors]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var chips = [].slice.call(sec.querySelectorAll('.sa-chip'));
      var imgs = sec.querySelectorAll('[data-colors-img]');
      var no = sec.querySelector('[data-colors-no]'), name = sec.querySelector('[data-colors-name]');
      var song = sec.querySelector('[data-colors-song]'), artist = sec.querySelector('[data-colors-artist]'), listen = sec.querySelector('[data-colors-listen]');
      var player = sec.querySelector('[data-colors-player]'), frame = player && player.querySelector('iframe');
      var stage = sec.querySelector('[data-colors-stage]'), soon = (sec.querySelector('[data-soon]') || { dataset: {} }).dataset.soon || '', swapT = 0;
      var piece = imgs[0] ? (imgs[0].alt || '').split(' in ')[0] : '';
      var cur = 0, token = 0;
      if (!chips.length || imgs.length < 2) return;
      function pick(chip, quiet) {
        chips.forEach(function (c) { var on = c === chip; c.classList.toggle('is-on', on); c.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        sec.style.setProperty('--tint', chip.style.getPropertyValue('--c').trim());
        if (no) no.textContent = 'Nº ' + chip.dataset.no;
        if (name) name.textContent = chip.dataset.name;
        if (song) song.textContent = chip.dataset.song || soon;
        if (artist) artist.textContent = chip.dataset.artist || '';
        var u = chip.dataset.url || '';
        if (listen) { listen.hidden = !u; listen.setAttribute('href', u || '#'); }
        if (player && frame) {
          var apple = /^https:\/\/music\.apple\.com\//.test(u);
          player.hidden = !apple;
          if (apple) { var e = u.replace('//music.apple.com/', '//embed.music.apple.com/'); if (frame.getAttribute('src') !== e) frame.setAttribute('src', e); } else frame.removeAttribute('src');
        }
        if (stage && !quiet && !reduce) { stage.classList.add('is-swap'); clearTimeout(swapT); swapT = setTimeout(function () { stage.classList.remove('is-swap'); }, 520); }
        var my = ++token, src = chip.dataset.src, pre = new Image();
        pre.onload = function () {
          if (my !== token) return;
          var next = imgs[1 - cur], prev = imgs[cur];
          next.src = src; next.alt = piece + ' in ' + chip.dataset.name; next.removeAttribute('aria-hidden');
          prev.alt = ''; prev.setAttribute('aria-hidden', 'true');
          prev.classList.remove('is-on'); next.classList.add('is-on'); cur = 1 - cur;
        };
        pre.src = src;
        if (!quiet && window.saSound) window.saSound('turn');
      }
      chips.forEach(function (c, i) {
        c.addEventListener('click', function () { pick(c); });
        c.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
          e.preventDefault(); var n = chips[(i + d + chips.length) % chips.length]; n.focus(); pick(n);
        });
      });
      var first = sec.querySelector('.sa-chip.is-on');
      if (first) sec.style.setProperty('--tint', first.style.getPropertyValue('--c').trim());
    });
  }

  /* Questions: a slim bar that opens when you hover it */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-faq]').forEach(function (sec) {
      if (sec.dataset.ready) return; sec.dataset.ready = '1';
      var dock = sec.querySelector('.sa-faq__dock'), btn = sec.querySelector('[data-faq-trigger]');
      if (!dock || !btn) return;
      var t = 0;
      function set(on) { clearTimeout(t); sec.classList.toggle('is-open', on); btn.setAttribute('aria-expanded', on ? 'true' : 'false'); }
      function busy() { return dock.contains(document.activeElement) && document.activeElement !== btn || !!dock.querySelector('details[open]'); }
      if (finePointer) {
        dock.addEventListener('pointerenter', function () { set(true); });
        dock.addEventListener('pointerleave', function () { clearTimeout(t); t = setTimeout(function () { if (!busy()) set(false); }, 700); });
      }
      btn.addEventListener('click', function () {
        var open = sec.classList.contains('is-open');
        if (finePointer && open && !btn.dataset.clicked) { btn.dataset.clicked = '1'; return; }
        btn.dataset.clicked = '1';
        if (open) dock.querySelectorAll('details[open]').forEach(function (d) { d.open = false; });
        set(!open);
      });
      sec.addEventListener('keydown', function (e) { if (e.key === 'Escape' && sec.classList.contains('is-open')) { set(false); btn.focus(); } });
      dock.addEventListener('focusin', function (e) { if (e.target !== btn) set(true); });
    });
  }

  /* Hero: a canvas that paints itself in muted blues and whites, and takes strokes from the cursor */
  function initPaint(root) {
    (root || document).querySelectorAll('[data-paint]').forEach(function (hero) {
      if (hero.dataset.paintReady) return; hero.dataset.paintReady = '1';
      var cv = hero.querySelector('[data-paint-canvas]'); if (!cv || !cv.getContext) return;
      var ctx = cv.getContext('2d'), no = hero.querySelector('[data-paint-no]');
      var W = 0, H = 0, dpr = 1, active = [], visible = true, raf = 0, count = 0, seed = 117, ambientT = 0, last = 0;
      var BLUES = ['#A9C6E8', '#8FB1DC', '#BCD3EE', '#7A9FD0', '#C9DCF2', '#9DBBE2'], WHITES = ['#FFFFFF', '#F6FAFE', '#EAF2FB'];
      function rnd() { seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }
      function size() {
        var r = hero.getBoundingClientRect(); dpr = Math.min(window.devicePixelRatio || 1, 2);
        W = Math.round(r.width); H = Math.round(r.height);
        cv.width = W * dpr; cv.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0); ctx.lineCap = 'butt';
        var g = ctx.createLinearGradient(0, 0, 0, H); g.addColorStop(0, '#C6DAF1'); g.addColorStop(.6, '#E2EDF9'); g.addColorStop(1, '#F8FBFF');
        ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);
      }
      function shade(hex, k) {
        var n = parseInt(hex.slice(1), 16), r = n >> 16, g = (n >> 8) & 255, b = n & 255;
        function c(v) { return Math.max(0, Math.min(255, Math.round(v + k * 255))); }
        return 'rgb(' + c(r) + ',' + c(g) + ',' + c(b) + ')';
      }
      /* a stroke is a bundle of bristles that follows one curve */
      function make(p, width, color, alpha, dur, delay) {
        var n = Math.max(14, Math.round(width / 1.7)), br = [];
        for (var i = 0; i < n; i++) {
          br.push({ o: (i / (n - 1) - .5) + (rnd() - .5) * .03, a: alpha * (.12 + rnd() * .5), w: 1.2 + rnd() * 3.6, c: shade(color, (rnd() - .5) * .08), t0: rnd() * .07, t1: 1 - rnd() * .12, gap: rnd() < .28 ? .25 + rnd() * .6 : 2, gl: .03 + rnd() * .09 });
        }
        return { p: p, width: width, br: br, dur: dur, delay: delay || 0, t: 0, start: 0, c: color, a: alpha };
      }
      function at(p, t) {
        var u = 1 - t, a = u * u * u, b = 3 * u * u * t, c = 3 * u * t * t, d = t * t * t;
        var x = a * p[0] + b * p[2] + c * p[4] + d * p[6], y = a * p[1] + b * p[3] + c * p[5] + d * p[7];
        var dx = 3 * u * u * (p[2] - p[0]) + 6 * u * t * (p[4] - p[2]) + 3 * t * t * (p[6] - p[4]);
        var dy = 3 * u * u * (p[3] - p[1]) + 6 * u * t * (p[5] - p[3]) + 3 * t * t * (p[7] - p[5]);
        var l = Math.sqrt(dx * dx + dy * dy) || 1;
        return [x, y, -dy / l, dx / l];
      }
      function seg(s, ta, tb) {
        var A = at(s.p, ta), B = at(s.p, tb);
        var ea = Math.pow(Math.sin(Math.PI * Math.min(1, Math.max(0, ta))), .6), eb = Math.pow(Math.sin(Math.PI * Math.min(1, Math.max(0, tb))), .6);
        var ha = s.width * .45 * Math.pow(Math.sin(Math.PI * Math.min(1, Math.max(0, ta))), .8), hb = s.width * .45 * Math.pow(Math.sin(Math.PI * Math.min(1, Math.max(0, tb))), .8);
        ctx.globalAlpha = s.a * .5; ctx.fillStyle = s.c;
        ctx.beginPath(); ctx.moveTo(A[0] + A[2] * ha, A[1] + A[3] * ha); ctx.lineTo(B[0] + B[2] * hb, B[1] + B[3] * hb); ctx.lineTo(B[0] - B[2] * hb, B[1] - B[3] * hb); ctx.lineTo(A[0] - A[2] * ha, A[1] - A[3] * ha); ctx.closePath(); ctx.fill();
        for (var i = 0; i < s.br.length; i++) {
          var b = s.br[i];
          if (tb < b.t0 || ta > b.t1 || (ta > b.gap && ta < b.gap + b.gl)) continue;
          ctx.globalAlpha = b.a; ctx.strokeStyle = b.c; ctx.lineWidth = b.w;
          ctx.beginPath();
          ctx.moveTo(A[0] + A[2] * b.o * s.width * ea, A[1] + A[3] * b.o * s.width * ea);
          ctx.lineTo(B[0] + B[2] * b.o * s.width * eb, B[1] + B[3] * b.o * s.width * eb);
          ctx.stroke();
        }
        ctx.globalAlpha = 1;
      }
      function ease(x) { return x < .5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2; }
      function tally() { count++; if (no) no.textContent = 'Stroke ' + ('00' + count).slice(-3); }
      function px(q) { return [q[0] * W, q[1] * H, q[2] * W, q[3] * H, q[4] * W, q[5] * H, q[6] * W, q[7] * H]; }
      var OPEN = [
        [[-.12, .30, .25, .06, .70, .34, 1.12, .12], .30, BLUES[0], .55, 2000, 0],
        [[1.12, .74, .70, .56, .30, .92, -.12, .66], .26, BLUES[1], .5, 2100, 220],
        [[-.12, .56, .30, .40, .66, .70, 1.12, .46], .34, WHITES[0], .8, 2200, 480],
        [[1.12, .16, .72, .30, .34, .02, -.12, .14], .20, BLUES[2], .6, 1900, 760],
        [[-.12, .92, .32, .80, .64, 1.02, 1.12, .86], .18, BLUES[3], .42, 2000, 980],
        [[.10, -.06, .34, .30, .58, .22, .96, .50], .22, WHITES[1], .75, 2000, 1250],
        [[1.12, .98, .74, .84, .40, .96, .04, .78], .16, WHITES[0], .7, 1900, 1500],
        [[-.12, .40, .22, .52, .52, .30, 1.12, .58], .12, BLUES[5], .4, 2100, 1750],
        [[.30, 1.04, .44, .70, .62, .78, .82, .40], .14, WHITES[2], .6, 2000, 2000]
      ];
      function opening(instant) {
        seed = 117; count = 0;
        OPEN.forEach(function (o) {
          var s = make(px(o[0]), o[1] * H, o[2], o[3], o[4], o[5]);
          if (instant) { for (var k = 0; k < 60; k++) seg(s, k / 60, (k + 1) / 60); tally(); } else active.push(s);
        });
      }
      function ambient() {
        var y0 = rnd(), y1 = rnd(), flip = rnd() < .5, white = rnd() < .5;
        var q = flip ? [1.12, y0, .7, y0 + (rnd() - .5) * .5, .3, y1 + (rnd() - .5) * .5, -.12, y1] : [-.12, y0, .3, y0 + (rnd() - .5) * .5, .7, y1 + (rnd() - .5) * .5, 1.12, y1];
        var pal = white ? WHITES : BLUES;
        active.push(make(px(q), (.08 + rnd() * .16) * H, pal[Math.floor(rnd() * pal.length)], white ? .55 : .38, 4200, 0));
      }
      function frame(now) {
        raf = 0; if (!visible) return;
        for (var i = active.length - 1; i >= 0; i--) {
          var s = active[i]; if (!s.start) s.start = now + s.delay;
          if (now < s.start) continue;
          var t = ease(Math.min(1, (now - s.start) / s.dur)), steps = Math.max(1, Math.ceil((t - s.t) * 60));
          for (var k = 0; k < steps; k++) seg(s, s.t + (t - s.t) * k / steps, s.t + (t - s.t) * (k + 1) / steps);
          s.t = t; if (t >= 1) { active.splice(i, 1); tally(); }
        }
        if (!reduce && !active.length && now - ambientT > 3600) { ambientT = now; ambient(); }
        raf = requestAnimationFrame(frame);
      }
      function go() { if (!raf && visible) raf = requestAnimationFrame(frame); }
      size();
      if (reduce) { opening(true); return; }
      var wait = document.documentElement.classList.contains('sa-seen') ? 150 : 1500;
      setTimeout(function () { opening(false); ambientT = performance.now() + 4000; go(); }, wait);

      /* the visitor's own brush */
      if (finePointer) {
        var lp = null, lt = 0, brush = null, hint = hero.querySelector('.sa-paint__hint');
        hero.addEventListener('pointermove', function (e) {
          if (e.target.closest('a, button, input, form')) { lp = null; return; }
          var r = hero.getBoundingClientRect(), x = e.clientX - r.left, y = e.clientY - r.top, now = performance.now();
          if (!lp || now - lt > 260) {
            var white = rnd() < .5, pal = white ? WHITES : BLUES, col = pal[Math.floor(rnd() * pal.length)];
            brush = make([0, 0, 0, 0, 0, 0, 0, 0], 60, col, white ? .6 : .45, 1, 0); lp = [x, y, 18]; lt = now; tally();
            if (hint) hint.classList.add('is-used');
            return;
          }
          var dx = x - lp[0], dy = y - lp[1], d = Math.sqrt(dx * dx + dy * dy); if (d < 3) return;
          var w = lp[2] + (Math.max(16, Math.min(84, d * 2.4)) - lp[2]) * .25, nx = -dy / d, ny = dx / d;
          var h0 = lp[2] * .45, h1 = w * .45, n0 = lp[3] === undefined ? nx : lp[3], n1 = lp[4] === undefined ? ny : lp[4];
          ctx.globalAlpha = brush.a * .45; ctx.fillStyle = brush.c;
          ctx.beginPath(); ctx.moveTo(lp[0] + n0 * h0, lp[1] + n1 * h0); ctx.lineTo(x + nx * h1, y + ny * h1); ctx.lineTo(x - nx * h1, y - ny * h1); ctx.lineTo(lp[0] - n0 * h0, lp[1] - n1 * h0); ctx.closePath(); ctx.fill();
          for (var i = 0; i < brush.br.length; i++) {
            var b = brush.br[i]; if (rnd() < .04) continue;
            ctx.globalAlpha = b.a; ctx.strokeStyle = b.c; ctx.lineWidth = b.w;
            ctx.beginPath(); ctx.moveTo(lp[0] + n0 * b.o * lp[2], lp[1] + n1 * b.o * lp[2]); ctx.lineTo(x + nx * b.o * w, y + ny * b.o * w); ctx.stroke();
          }
          ctx.globalAlpha = 1; lp = [x, y, w, nx, ny]; lt = now;
        }, { passive: true });
        hero.addEventListener('pointerleave', function () { lp = null; });
      }
      var rw = W;
      window.addEventListener('resize', function () {
        clearTimeout(last); last = setTimeout(function () { var r = hero.getBoundingClientRect(); if (Math.abs(r.width - rw) < 2) return; rw = r.width; active = []; size(); opening(true); }, 200);
      }, { passive: true });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; go(); }).observe(hero);
    });
  }

  /* Inspect the jacket: small photos, a lens to look closer, and a pin that shows where it is */
  function initInspect(root) {
    (root || document).querySelectorAll('[data-inspect]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var chips = [].slice.call(box.querySelectorAll('.sa-inspect__chip')); if (!chips.length) return;
      var lens = box.querySelector('[data-inspect-lens]'), no = box.querySelector('[data-inspect-no]');
      var title = box.querySelector('[data-inspect-title]'), note = box.querySelector('[data-inspect-note]'), where = box.querySelector('[data-inspect-where]');
      var tourBtn = box.querySelector('[data-inspect-tour]'), tourLabel = box.querySelector('[data-inspect-tour-label]');
      var sec = box.closest('section') || document, stage = sec.querySelector('[data-stage]');
      var pin = stage && stage.querySelector('[data-stage-pin]'), pinNo = pin && pin.querySelector('[data-stage-pin-no]');
      var cur = 0, pinView = '', touring = false, t0 = 0, raf = 0, STEP = 3600;
      function two(n) { return ('0' + n).slice(-2); }
      function hidePin() { if (pin) pin.hidden = true; pinView = ''; }
      function pick(i, user) {
        cur = (i + chips.length) % chips.length; var c = chips[cur];
        chips.forEach(function (x, k) { x.classList.toggle('is-on', k === cur); x.setAttribute('aria-pressed', k === cur ? 'true' : 'false'); });
        if (no) no.textContent = two(cur + 1);
        if (title) title.textContent = c.dataset.title || '';
        if (note) note.textContent = c.dataset.note || '';
        if (lens) {
          lens.classList.add('is-swap'); lens.setAttribute('aria-label', c.dataset.title || '');
          var im = new Image(); im.onload = function () { lens.style.backgroundImage = 'url("' + c.dataset.src + '")'; lens.classList.remove('is-swap'); };
          im.onerror = function () { lens.classList.remove('is-swap'); }; im.src = c.dataset.src;
          lens.style.setProperty('--zx', '50%'); lens.style.setProperty('--zy', '50%');
        }
        var v = c.dataset.view;
        if (where) where.textContent = v ? (v === 'back' ? 'Back of the jacket' : 'Front of the jacket') + ' · marked ' + two(cur + 1) : '';
        if (stage && pin && v && (user || touring)) {
          var b = stage.querySelector('[data-view="' + v + '"]'); if (b) b.click();
          pin.style.setProperty('--px', (parseFloat(c.dataset.x) || 50) + '%'); pin.style.setProperty('--py', (parseFloat(c.dataset.y) || 50) + '%');
          if (pinNo) pinNo.textContent = two(cur + 1);
          pin.hidden = true; pinView = v;
          setTimeout(function () { if (pinView === v) pin.hidden = false; }, reduce ? 0 : 650);
          if (!reduce) { stage.classList.remove('is-scan'); void stage.offsetWidth; stage.classList.add('is-scan'); }
        } else hidePin();
        if (user && c.scrollIntoView && box.querySelector('.sa-inspect__strip').scrollWidth > box.querySelector('.sa-inspect__strip').clientWidth) c.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
      }
      function stopTour() { touring = false; cancelAnimationFrame(raf); box.classList.remove('is-touring'); if (tourBtn) tourBtn.setAttribute('aria-pressed', 'false'); if (tourLabel) tourLabel.textContent = 'Walk me through'; }
      function tick(now) {
        if (!touring) return;
        var p = (now - t0) / STEP; box.style.setProperty('--tour', Math.min(1, p).toFixed(3));
        if (p >= 1) { t0 = now; pick(cur + 1, false); }
        raf = requestAnimationFrame(tick);
      }
      chips.forEach(function (c, i) {
        c.addEventListener('click', function (e) { if (e.isTrusted !== false) stopTour(); pick(i, true); });
        c.addEventListener('keydown', function (e) { var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return; e.preventDefault(); stopTour(); pick(i + d, true); chips[cur].focus(); });
      });
      if (tourBtn) tourBtn.addEventListener('click', function () {
        if (touring) { stopTour(); return; }
        touring = true; box.classList.add('is-touring'); tourBtn.setAttribute('aria-pressed', 'true'); if (tourLabel) tourLabel.textContent = 'Pause';
        pick(cur, false); t0 = performance.now(); raf = requestAnimationFrame(tick);
      });
      if (lens) {
        function move(e) { var r = lens.getBoundingClientRect(); lens.style.setProperty('--zx', Math.max(0, Math.min(100, (e.clientX - r.left) / r.width * 100)).toFixed(1) + '%'); lens.style.setProperty('--zy', Math.max(0, Math.min(100, (e.clientY - r.top) / r.height * 100)).toFixed(1) + '%'); }
        lens.addEventListener('pointerenter', function (e) { lens.classList.add('is-zoom'); move(e); });
        lens.addEventListener('pointermove', move);
        lens.addEventListener('pointerdown', function (e) { lens.classList.add('is-zoom'); move(e); });
        lens.addEventListener('pointerleave', function () { lens.classList.remove('is-zoom'); lens.style.setProperty('--zx', '50%'); lens.style.setProperty('--zy', '50%'); });
      }
      if (stage) {
        stage.querySelectorAll('[data-view]').forEach(function (b) { b.addEventListener('click', function (e) { if (b.dataset.view !== pinView) hidePin(); }); });
        stage.addEventListener('pointerdown', function (e) { if (!e.target.closest('[data-view]')) { hidePin(); stopTour(); } });
      }
      pick(0, false);
    });
  }

  function initSignature(root) {
    initChars(root); initMonitor(root); initSky(root); initTether(root); initClouds(root); initWorld(root); initColors(root); initFaq(root); initPaint(root); initInspect(root); initZip(root);
    initSpotlight(root); initMagnets(root); initParallax(root);
    initFlashlight(root); initHotspots(root); initMarquee(root); initShare(root);
    initProduct(root); initDedicate(root); initBlueprint(root); initEdition(root); initEditionFx(root); initHouse(root); initTees(root); initQuickbuy(root); initFinder(root);
    if (window.saInitSound) window.saInitSound(root);
  }

  function init(root) {
    initSignature(root);
    initReveals(root);
    initWords(root);
    initStage(root);
    initCountdown(root);
  }

  document.documentElement.classList.add('js');
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHeader(); initProgress(); initCursor(); initTabTitle(); initForms(); init(); initBag(); initBuybar(); initLight(); initSheet(); initProof(); initBurst(); markSeen(); });
  } else { initHeader(); initProgress(); initCursor(); initTabTitle(); initForms(); init(); initBag(); initBuybar(); initLight(); initSheet(); initProof(); initBurst(); markSeen(); }

  /* Theme editor: re-run when a section is added or changed */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
